
(function() {
  var params = new URLSearchParams(window.location.search);
  if (params.get('utm_campaign')) {
    sessionStorage.setItem('bb_utm_campaign', params.get('utm_campaign'));
    localStorage.setItem('bb_utm_campaign', params.get('utm_campaign'));
  }
  if (params.get('utm_content')) {
    sessionStorage.setItem('bb_utm_content', params.get('utm_content'));
    localStorage.setItem('bb_utm_content', params.get('utm_content'));
  }
  if (params.get('utm_source')) {
    sessionStorage.setItem('bb_utm_source', params.get('utm_source'));
    localStorage.setItem('bb_utm_source', params.get('utm_source'));
  }
  if (params.get('ad')) {
    sessionStorage.setItem('bb_ad', params.get('ad'));
    localStorage.setItem('bb_ad', params.get('ad'));
    localStorage.setItem('bb_ad_ts', String(Date.now()));   // 24h TTL clock for stored-key styling (bbActiveAdKey)
  }
})();

(function() {

  let selectedSize = 6;
  let selectedPrice = 19.99;
  let selectedVariantId = '52900084973904';
  const quantities = {};
  let userHasAdjusted = false;

  // Journey Intelligence: fire 'builder','start' once, on the first active build action
  // (size chosen or first flavour added). Guarded so it never repeats.
  function bbBuilderStart() {
    if (window.__bbBuilderStarted) return;
    window.__bbBuilderStarted = true;
    window.bbTrack && bbTrack('builder', 'start');
  }
  // Journey Intelligence: reached-checkout (fires once per page, from either the "Add to
  // bag" submit OR the express/wallet button) + a terminal personalise done/skipped flag.
  // walletVal (optional) records the express path was used. NO personalisation content sent.
  function bbCheckoutReached(walletVal) {
    if (!window.bbTrack) return;
    if (walletVal) bbTrack('wallet', walletVal);
    if (window.__bbCheckoutFired) return;
    window.__bbCheckoutFired = true;
    bbTrack('checkout', 'reached');
    bbTrack('personalise', (window.bbStoryState && window.bbStoryState.story) ? 'done' : 'skipped');
  }

  // Journey Intelligence: personalise REVERT — customer FILLED the personaliser then undid it
  // (keep-it-classic, card toggle-off, the "Remove personalisation" button, or manually
  // clearing their name/date/story). Shared on window so BOTH the build-your-box flow and the
  // gifting personaliser (make-it-personal.liquid) report through the SAME once-per-visitor
  // guard. Content-checked so opened-but-empty + programmatic resets never count.
  window.bbPersoHasContent = function () {
    var root = document.getElementById('bb-personalise-collapse');
    if (!root) return false;
    var els = root.querySelectorAll('input[type="text"], textarea');
    for (var i = 0; i < els.length; i++) { if ((els[i].value || '').trim()) return true; }
    return false;
  };
  window.bbTrackReverted = function () {
    if (window.__bbRevertedFired) return;
    window.__bbRevertedFired = true;
    window.bbTrack && bbTrack('personalise', 'reverted');
  };
  window.bbTrackRevertedIfFilled = function () {
    if (window.bbPersoHasContent()) window.bbTrackReverted();
  };
  // Manual clear: the customer deletes their entered text down to nothing. Only USER edits
  // fire 'input' (programmatic wipes set .value directly and don't), so this catches hand-
  // clearing without double-firing on the button paths above. Fires only on the transition
  // to fully-empty after having had content.
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || (t.tagName !== 'INPUT' && t.tagName !== 'TEXTAREA')) return;
    if (!t.closest || !t.closest('#bb-personalise-collapse')) return;
    if (window.bbPersoHasContent()) { window.__bbPersoHadContent = true; }
    else if (window.__bbPersoHadContent) { window.bbTrackReverted(); }
  }, true);

  // ── Personalisation funnel analytics ──────────────────────────────────
  // One helper fires each step to GA4 (gtag event), the dataLayer, AND Journey Intelligence, so the
  // whole Step-3 funnel (viewed → opened → focused → entered → type/top-line → skip/remove/reopen →
  // completed) is measurable. `once` de-dupes an event per page load.
  window.__bbPersoFired = {};
  window.bbPersoTrack = function (name, params, once) {
    if (once) { if (window.__bbPersoFired[name]) return; window.__bbPersoFired[name] = true; }
    params = params || {};
    try { if (typeof gtag !== 'undefined') gtag('event', name, params); } catch (e) {}
    try { if (window.dataLayer) window.dataLayer.push(Object.assign({ event: name }, params)); } catch (e) {}
    try { if (window.bbTrack) bbTrack('personalise_funnel', name, String(params.type || params.choice || '')); } catch (e) {}
  };

  // ── Gifting page pricing ─────────────────────────────────────────────
  // Higher base that already includes date/name personalisation (no +£2); only
  // the chapter/story adds £5. Reuses existing same-price variants.
  var BB_GIFTING = !!window.BB_GIFTING;
  window.BB_GIFTING = BB_GIFTING;
  var GIFTING_BASE    = { 6: { variant: '52900084973904', price: 19.99 }, 12: { variant: '52900085006672', price: 33.99 } };
  var GIFTING_CHAPTER = { 6: { variant: '53223813120336', price: 26.99 }, 12: { variant: '53223813284176', price: 42.99 } };
  if (BB_GIFTING) { selectedPrice = GIFTING_BASE[6].price; selectedVariantId = GIFTING_BASE[6].variant; }

  // ── Step 3 personalisation: dedicated product variants override the box ──
  // When a Step 3 option is chosen, the form submits its dedicated variant
  // (all variants of custom-build-a-box, so Add-to-bag AND express both work).
  window.bbStoryState = window.bbStoryState || { story: null };
  var STORY_PRODUCTS = {
    'Remember when': { 6: { variant: '53223813054800', price: 24.99 }, 12: { variant: '53223813316944', price: 38.99 } },
    'Tell a story':  { 6: { variant: '53223813120336', price: 26.99 }, 12: { variant: '53223813382480', price: 42.99 } },
    'Names':         { 6: { variant: '53223811776848', price: 24.99 }, 12: { variant: '53223811842384', price: 38.99 } }
  };
  // Remember-when with the "six dates" tick box on (box of 6 only) — its own
  // variant at +£2 over the single-date Remember-when price.
    var SIX_DATES_PRODUCT = {
    6:  { variant: '53223813087568', price: 28.99 },
    12: { variant: '53223813349712', price: 42.99 } // Dates on each bar (box of 12)
  };
  // Names with "a name on each bar" on — its own variant at +£2, both sizes.
  var NAMES_PER_BAR = { 6: { variant: '53223813022032', price: 28.99 }, 12: { variant: '53223813284176', price: 42.99 } };
  // Message-first "Personalised" variants: one message on all six (+£5) vs a unique message per bar (+£9).
  var MESSAGE_PRODUCTS = {
    // Box of 6 → "Your personalised box" (handle make-your-own) so the cart line carries that
    // product/title (Barney, 2026-08-17). Box of 12 keeps the Personalised-box Names variant.
    one:   { 6: { variant: '53400089592144', price: 24.99 }, 12: { variant: '53223811842384', price: 38.99 } },
    multi: { 6: { variant: '53334210806096', price: 28.99 }, 12: { variant: '53223813284176', price: 42.99 } }
  };
  // Personaliser engaged? (open collapse; self-buy collapses via .bb-selfbuy:not(.is-open))
  function giftPersoActive() {
    var box = document.getElementById('bb-personalise-collapse');
    if (!box || box.hidden) return false;
    // Skip (gifting): the collapse only gets [hidden] after a 500ms fold, but doSkip reprices
    // immediately — so read the Skip button's collapsed state (aria-expanded="false", set up-front)
    // to treat "skipping" as inactive right away. gifting-only button; null elsewhere.
    var closeBtn = document.getElementById('bb-perso-close');
    if (closeBtn && closeBtn.getAttribute('aria-expanded') === 'false') return false;
    var sec = box.closest ? box.closest('.bb-story-section') : null;
    if (sec && sec.classList.contains('bb-selfbuy') && !sec.classList.contains('is-open')) return false;
    return true;
  }
  // Any personalisation content typed? Read the RAW visible personaliser fields (not the hidden mb-*
  // props, which lag/aren't cleared on delete) so the price reacts the instant the last field is emptied.
  function bbHasPersoContent() {
    var SELS = ['#mb-first-occasion', '.mb-drow-label', '.mb-drow-name', '.mb-drow-date',
      '.mb-bar-msg', '.mb-bar-name', '.mb-first-date', '.mb-first-name',
      '#mb-name-line', '#mb-anecdote-line', '#mb-sharedname'];
    for (var i = 0; i < SELS.length; i++) {
      var els = document.querySelectorAll(SELS[i]);
      for (var j = 0; j < els.length; j++) { if ((els[j].value || '').trim()) return true; }
    }
    return false;
  }
  window.bbHasPersoContent = bbHasPersoContent;   // shared with the radio-state sync in make-it-personal
  function storyOverride() {
    var s = window.bbStoryState && window.bbStoryState.story;
    // Price by personalisation CONTENT — never by mere selection. No content → classic base price, and the
    // moment the last input is cleared it reverts. On the GIFTING page, collapsing (Skip) also reverts, so
    // the section must be open (giftPersoActive). On build-your-box, collapsing PRESERVES the personalisation
    // (content stays priced) — only "remove" reverts — so it is NOT gated on the section being open.
    if (!bbHasPersoContent()) return null;
    if (document.querySelector('.bb-page--giftpage') && !giftPersoActive()) return null;
    // Gifting message-first (no date/name/story card chosen): price by one message vs a unique
    // message per bar. .bb-gift-6on = the "Six unique messages" radio is on.
    // Pure message personalisation (no Date/Name top-line) routes to the message product even
    // though applyStoryPricing labels it 'Remember when' — otherwise the STORY_PRODUCTS lookup
    // below wins and the cart line lands on the "Box of 6 / Dates" variant. Six-unique is the
    // only flow now and still prices as ONE message (+£5, £24.99); the 'multi' (+£9) variant is
    // retired from this step (Barney, 2026-08-17).
    if ((BB_GIFTING ? giftPersoActive() : true) && (!s || s === 'Remember when')) {
      var _mmPure = document.getElementById('mb-memory-mode');
      var pureMsg = !_mmPure || (!_mmPure.classList.contains('show-date') && !_mmPure.classList.contains('show-name'));
      if (pureMsg) {
        var mp = MESSAGE_PRODUCTS['one'];
        if (mp && mp[selectedSize]) return mp[selectedSize];
      }
    }
    // Gifting AND build-your-box route each personalisation type to its own dedicated
    // variant (identical variants/prices). Gifting previously shared one variant
    // (GIFTING_CHAPTER / GIFTING_BASE) for every type, which mislabelled the box-12
    // Chapters and Dates-on-each-bar (and single Date-12 / Name-6) as the wrong variant.
    // Six-unique messages price as the standard Remember-when variant (+£5, £24.99) — the
    // SIX_DATES_PRODUCT +£9 override is retired on this flow (Barney, 2026-08-17). sixDates
    // stays true for serialisation; it just no longer changes the variant/price.

    if (s === 'Names' && window.bbStoryState && window.bbStoryState.namesPerBar && NAMES_PER_BAR[selectedSize]) {
      return NAMES_PER_BAR[selectedSize];
    }
    if (s && STORY_PRODUCTS[s] && STORY_PRODUCTS[s][selectedSize]) return STORY_PRODUCTS[s][selectedSize];
    return null;
  }
  function effectiveVariant() { var o = storyOverride(); return o ? o.variant : selectedVariantId; }
  function effectivePrice()   { var o = storyOverride(); return o ? o.price   : selectedPrice; }

  // Build-your-box: reflect personalisation state in the subtitle under "Step 3: Personalise".
  // Empty → "No personalisation added"; filled → "Personalisation added +£X" + an underlined "remove".
  function updatePersoStateSub() {
    var el = document.getElementById('bb-perso-state');
    if (!el) return;
    // Only show the state line when the section is CLOSED and has been interacted with (opened once).
    // While it's open you're editing the inputs; before any interaction it stays hidden entirely.
    if (!window.__bbPersoInteracted || window.__bbPersoOpen) { el.hidden = true; return; }
    el.hidden = false;
    var textEl = el.querySelector('.bb-perso-state-text');
    var removeEl = el.querySelector('.bb-perso-state-remove');
    var o = storyOverride();
    if (o) {
      if (textEl) textEl.textContent = 'Personalisation added · ';   // "Personalisation added · remove"
      if (removeEl) removeEl.hidden = false;
    } else {
      if (textEl) textEl.textContent = 'No personalisation added';
      if (removeEl) removeEl.hidden = true;
    }
  }
  window.bbUpdatePersoStateSub = updatePersoStateSub;   // let the accordion open-handlers reveal it after interaction
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('#bb-perso-state-remove')) return;
    e.preventDefault(); e.stopPropagation();
    if (window.bbPersoTrack) window.bbPersoTrack('personalisation_removed', { type: 'single_message' });
    if (window.bbTrimToSingle) window.bbTrimToSingle();
    if (window.bbKeepClassic) window.bbKeepClassic();   // wipes fields + reverts to the base price
    if (window.bbRefreshForStory) window.bbRefreshForStory();
    updatePersoStateSub();
  }, true);
  var refreshDelivery = function() {}; // assigned by the delivery block below

// Default prefills (no ad)
  // NOTE: Orange + Chocolate Pretzel are temporarily out of stock (cards commented out in
  // flavour-picker.liquid); Raspberry is back. Keep these prefills in sync with the rendered cards —
  // a default that names a card-less flavour silently drops that bar (5/6, 10/12 boxes).
  const defaultPrefill6 = { 'Caramel': 1, 'Malt Cornflakes': 2, 'Peanut Butter': 1, 'Chocolate Pretzel': 1, 'Raspberry': 1 };   // Caramel back (Barney 2026-08-24); feed defaultLineup overrides when reachable
  const defaultPrefill12 = { 'Caramel': 2, 'Malt Cornflakes': 4, 'Peanut Butter': 2, 'Chocolate Pretzel': 2, 'Raspberry': 2 };

  // Read ad flavour (if any) so we can build an ad-aware prefill
  function getAdFlavour() {
    var params = new URLSearchParams(window.location.search);
    var adKey = params.get('ad');
    if (!adKey || !window.adConfigs || !window.adConfigs[adKey]) return null;
    var f = window.adConfigs[adKey].flavour || null;
    if (!f) return null;
    // Retired-lead guard (2026-08-21): an ad config can outlive its flavour — the Caramel-keyed
    // self-treat ads broke on 20 Aug when the lineup hid the card (landings showed 5-of-6 bars
    // with every + disabled). Only a currently SELECTABLE card may lead the box; otherwise the
    // ad keeps its copy/hero/attribution and the box falls back to the standard default mix.
    var card = document.querySelector('.bb-flavour-card[data-flavour="' + f + '"]');
    if (!card || card.classList.contains('bb-flav-off') || card.classList.contains('bb-flavour-card--locked')) return null;
    return f;
  }

  // Build prefill when an ad flavour is active.
  // Box of 6: 1 of the ad flavour + 5 filler flavours ×1 → SIX DISTINCT flavours (so the selector shows
  //           6 highlighted cards matching the 6/6 counter — no doubled card that reads as "5 selected").
  // Box of 12: 4 of the ad flavour + 4 fillers ×2.
  // Fillers are sourced from the REAL flavour cards (in a preferred order), so the box ALWAYS fills to
  // exactly `size` and NEVER uses the weekly Special or a locked/non-existent flavour. The old list was
  // hard-coded and included "Hazelnut" — which has no card, so that bar silently vanished (5/6, 10/12).
  var AD_FILLER_ORDER = ['Caramel', 'Peanut Butter', 'Raspberry', 'Chocolate Pretzel', 'Malt Cornflakes', 'Orange'];   // Pistachio unselectable 2026-08-16; Caramel restored 2026-08-24
  function buildAdPrefill(adFlavour, size) {
    // Six-boxes seed the AD flavour at 2 (Barney 2026-08-25): the old value of 1 relied on the
    // wrap loop to double it, which only fired when distinct fillers ran short — Caramel's
    // return made six flavours available, the wrap never ran, and ad landings quietly became a
    // generic one-of-each box. Doubling up front keeps the landing led by the advertised bar
    // regardless of how many flavours are live (the least-preferred filler drops instead).
    var adQty = size === 12 ? 4 : 2;
    var fillerQty = size === 12 ? 2 : 1;
    var specialCard = document.getElementById('bb-special-card');
    var special = specialCard ? specialCard.dataset.flavour : null;
    var avail = [].slice.call(document.querySelectorAll('.bb-flavour-card:not(.bb-flavour-card--locked):not(.bb-flav-off)'))
      .map(function (c) { return c.dataset.flavour; })
      .filter(function (f) { return f && f !== adFlavour && f !== special; })
      .sort(function (a, b) {
        var ia = AD_FILLER_ORDER.indexOf(a), ib = AD_FILLER_ORDER.indexOf(b);
        return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
      });
    var prefill = {};
    prefill[adFlavour] = adQty;
    var need = size - adQty;                                       // bars still to place
    var fillers = avail.slice(0, Math.ceil(need / fillerQty));     // enough distinct fillers to cover `need`
    for (var i = 0; i < fillers.length && need > 0; i++) {
      var q = Math.min(fillerQty, need);
      prefill[fillers[i]] = (prefill[fillers[i]] || 0) + q;
      need -= q;
    }
    // Wrap when the lineup is short (found 2026-08-21: with 5 selectable flavours a 6-box ad
    // landing shipped 5-of-6 bars — distinct fillers ran out and the box never filled).
    // Extras go to the AD flavour first — double the advertised bar (Barney 2026-08-22),
    // then cycle the fillers.
    var wrapOrder = [adFlavour].concat(avail);
    var w = 0;
    while (need > 0 && wrapOrder.length) {
      var fw = wrapOrder[w % wrapOrder.length];
      prefill[fw] = (prefill[fw] || 0) + 1;
      need--; w++;
    }
    return prefill;
  }

function isSpecialUnlocked() {
  try {
    return localStorage.getItem('bb_special_unlocked') === '1';
  } catch (e) {
    return false;
  }
}

function getSpecialFlavourName() {
  const card = document.getElementById('bb-special-card');
  return card ? card.dataset.flavour : null;
}

function applySpecialToPrefill(prefill) {
  if (!isSpecialUnlocked()) return prefill;

  const specialName = getSpecialFlavourName();
  if (!specialName) return prefill;

  // Clone so we don't mutate the original
  const result = Object.assign({}, prefill);

  // Reduce Malt Cornflakes by 1 to make room
  if (result['Malt Cornflakes'] && result['Malt Cornflakes'] > 0) {
    result['Malt Cornflakes'] = result['Malt Cornflakes'] - 1;
    if (result['Malt Cornflakes'] === 0) {
      delete result['Malt Cornflakes'];
    }
  }

  // Add 1 special
  result[specialName] = (result[specialName] || 0) + 1;

  return result;
}

function getPrefill(size) {
  var adFlavour = getAdFlavour();
  // The default box never includes the special (the defaults above cover the box instead). The
  // special is only ever added by the customer manually once the dashboard has it public + unlocked.
  return adFlavour ? buildAdPrefill(adFlavour, size) : (size === 12 ? defaultPrefill12 : defaultPrefill6);
}

  // Backwards-compat references — keep names in case used elsewhere
  const prefill6 = getPrefill(6);
  const prefill12 = getPrefill(12);

  // ─── GA4 VIEW ITEM ───────────────────────────────
  function trackBabViewItem() {
    try {
      var itemData = [{
        item_id: 'custom-build-a-box',
        item_name: 'Build a Box',
        price: selectedPrice,
        quantity: 1
      }];
      if (typeof gtag !== 'undefined') {
        gtag('event', 'view_item', {
          currency: 'GBP',
          value: selectedPrice,
          items: itemData
        });
      }
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'view_item',
          ecommerce: {
            currency: 'GBP',
            value: selectedPrice,
            items: itemData
          }
        });
      }
    } catch(e) {}
  }

  // ─── EXPRESS CHECKOUT TRACKING ──────────────────
  function trackExpressCheckout() {
    try {
      var itemData = [{
        item_id: 'custom-build-a-box',
        item_name: 'Build a Box',
        price: selectedPrice,
        quantity: 1
      }];
      if (typeof gtag !== 'undefined') {
        gtag('event', 'begin_checkout', {
          currency: 'GBP',
          value: selectedPrice,
          items: itemData
        });
      }
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'begin_checkout',
          ecommerce: {
            currency: 'GBP',
            value: selectedPrice,
            items: itemData
          }
        });
      }
    } catch(e) {}
  }


  // ─── GA4 FLAVOUR TRACKING ────────────────────────
  function trackBabAddToCart() {
    try {
      var eventData = {
        box_size: selectedSize,
        value: selectedPrice,
        currency: 'GBP',
        occasion: selectedOccasion
      };
      Object.entries(quantities).forEach(function(entry) {
        if (entry[1] > 0) {
          var key = 'bar_' + entry[0].toLowerCase().replace(/\s+/g, '_');
          eventData[key] = entry[1];
        }
      });

      // Custom flavour event
      if (typeof gtag !== 'undefined') {
        gtag('event', 'bab_add_to_cart', eventData);
      }
      if (window.dataLayer) {
        window.dataLayer.push(Object.assign({ event: 'bab_add_to_cart' }, eventData));
      }

      // Standard GA4 + Meta add_to_cart event
      var itemData = [{
        item_id: 'custom-build-a-box',
        item_name: 'Build a Box',
        price: selectedPrice,
        quantity: 1
      }];
      if (typeof gtag !== 'undefined') {
        gtag('event', 'add_to_cart', {
          currency: 'GBP',
          value: selectedPrice,
          items: itemData
        });
      }
     if (window.dataLayer) {
        window.dataLayer.push({
          event: 'add_to_cart',
          ecommerce: {
            currency: 'GBP',
            value: selectedPrice,
            items: itemData
          }
        });
      }


// Send to Klaviyo
      if (window._learnq) {
        var flavoursList = [];
        Object.entries(quantities).forEach(function(entry) {
          if (entry[1] > 0) flavoursList.push(entry[1] + 'x ' + entry[0]);
        });
        var boxDesc = selectedSize === 12 ? 'Twelve handmade filled bars' : 'Six handmade filled bars';
        var occasionLabel = selectedOccasion.charAt(0).toUpperCase() + selectedOccasion.slice(1).replace('-', ' ');

        window._learnq.push(['track', 'Added to Cart', {
          '$value': selectedPrice,
          'ProductName': 'Build a Box',
          'BoxSize': selectedSize,
          'BoxDescription': boxDesc,
          'Flavours': flavoursList.join(', '),
          'Occasion': occasionLabel,
          'Variant': occasionLabel + ' ' + selectedSize,
          'ImageURL': occasionImages[selectedOccasion][selectedSize],
          'ProductID': 'custom-build-a-box'
        }]);
      }
    } catch(e) {}
  }

  function applyQuantities(qtyMap) {
    const specialCard = document.getElementById('bb-special-card');
    const specialLocked = specialCard && specialCard.classList.contains('bb-flavour-card--locked');
    const specialFlavourName = specialCard ? specialCard.dataset.flavour : null;
    const adjustedMap = Object.assign({}, qtyMap);
    if (specialLocked && specialFlavourName && adjustedMap[specialFlavourName]) {
      adjustedMap['Chocolate Pretzel'] = (adjustedMap['Chocolate Pretzel'] || 0) + adjustedMap[specialFlavourName];   // Caramel retired 2026-08-19
      delete adjustedMap[specialFlavourName];
    }
    document.querySelectorAll('.bb-flavour-card:not(.bb-flavour-card--locked)').forEach(function(card) {
      const flavour = card.dataset.flavour;
      const qty = adjustedMap[flavour] || 0;
      quantities[flavour] = qty;
      card.querySelector('.bb-qty-num').textContent = qty;
      card.classList.toggle('has-quantity', qty > 0);
    });
  }

  function getCurrentQuantities() {
    const result = {};
    Object.keys(quantities).forEach(function(k) { result[k] = quantities[k]; });
    return result;
  }


  const occasionPlaceholders = {
    'classic':         'Just a little something...',
    'birthday':        'Happy Birthday - hope this makes your day even better',
    'thank-you':       'A small thank you - very well deserved',
    'thinking-of-you': 'Just a little something to brighten your day',
    'well-done':       "Well done - you've earned this"
  };

  function updateGiftPlaceholder() {
    setTimeout(function() {
      document.querySelectorAll('.bb-cart-gift__textarea, #CartGiftMessage').forEach(function(textarea) {
        if (textarea.value !== '') return;
        const newPlaceholder = occasionPlaceholders[selectedOccasion] || 'Just a little something...';
        textarea.value = ' ';
        textarea.setAttribute('placeholder', newPlaceholder);
        textarea.placeholder = newPlaceholder;
        setTimeout(function() { textarea.value = ''; }, 10);
      });
    }, 50);
  }

  let selectedOccasion = 'classic';

  const occasionVariants = {
    'classic':         { 6: '52900084973904', 12: '52900085006672' },
    'birthday':        { 6: '52900552016208', 12: '52900552048976' },
    'thank-you':       { 6: '52900552081744', 12: '52900552114512' },
    'thinking-of-you': { 6: '52900552147280', 12: '52900552180048' },
    'well-done':       { 6: '52900552212816', 12: '52900552245584' }
  };

  const occasionImages = {
    'classic':         { 6: 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Buildaboxof6.jpg?v=1769446127&width=750', 12: 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Buildabox12copy.jpg?v=1769858137&width=750' },
    'birthday':        { 6: 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/birthday_boxof6_build.png?v=1776079057', 12: 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/birthday_boxof12_build.png?v=1776079013' },
    'thank-you':       { 6: 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/thankyou_boxof6_build.png?v=1776079140', 12: 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/thankyou_boxof12_build.png?v=1776078958' },
    'thinking-of-you': { 6: 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/thinkingofyou_boxof6_build.png?v=1776081317', 12: 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Thinkingofyou_boxof12_build.png?v=1776078929' },
    'well-done':       { 6: 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/welldone_boxof6_build.png?v=1776079079', 12: 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/welldone_boxof12_build.png?v=1776078983' }
  };

  function updateSizeCardImages() {
    const img6 = document.querySelector('.bb-size-card[data-size="6"] .bb-size-card-img');
    const img12 = document.querySelector('.bb-size-card[data-size="12"] .bb-size-card-img');
    if (img6) img6.src = occasionImages[selectedOccasion][6];
    if (img12) img12.src = occasionImages[selectedOccasion][12];
  }

  function updateOccasionVariant() {
    selectedVariantId = occasionVariants[selectedOccasion][selectedSize];
    syncForm();
    updateCTA();
  }

  var _giftRowEl = document.getElementById('bb-gift-row');
  if (_giftRowEl) _giftRowEl.addEventListener('click', function() {
    const checkbox = document.getElementById('bb-gift-checkbox');
    const wrap = document.getElementById('bb-occasion-wrap');
    const giftWrap = document.getElementById('bb-gift-message-wrap');
    const isChecked = checkbox.classList.toggle('checked');
    wrap.classList.toggle('visible', isChecked);
    if (giftWrap) giftWrap.classList.toggle('visible', isChecked);
    if (!isChecked) {
      selectedOccasion = 'classic';
      document.querySelectorAll('.bb-occasion-btn').forEach(function(b) { b.classList.remove('selected'); });
      document.querySelector('.bb-occasion-btn[data-occasion="classic"]').classList.add('selected');
      updateSizeCardImages();
      updateOccasionVariant();
    }
  });

  document.querySelectorAll('.bb-occasion-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.bb-occasion-btn').forEach(function(b) { b.classList.remove('selected'); });
      btn.classList.add('selected');
      selectedOccasion = btn.dataset.occasion;
      updateSizeCardImages();
      updateOccasionVariant();
      updateGiftPlaceholder();
    });
  });

  document.querySelectorAll('.bb-size-card').forEach(function(el) {
    el.addEventListener('click', function() {
      bbBuilderStart();   // Journey Intelligence: builder is now active
      window.bbTrack && bbTrack('builder', 'box_size', el.dataset.size);   // engagement: box-size chosen
      const prevSize = selectedSize;
      const prevQtys = getCurrentQuantities();
      document.querySelectorAll('.bb-size-card').forEach(function(s) { s.classList.remove('selected'); });
      el.classList.add('selected');
      selectedSize = parseInt(el.dataset.size);
      selectedPrice = parseFloat(el.dataset.price);
      selectedVariantId = occasionVariants[selectedOccasion][selectedSize];
      if (BB_GIFTING && GIFTING_BASE[selectedSize]) {
        selectedPrice = GIFTING_BASE[selectedSize].price;
        selectedVariantId = GIFTING_BASE[selectedSize].variant;
      }
      try { updateFoot(); } catch (e) {}   // refresh the names "all N of your bars" line on size change

      if (!userHasAdjusted) {
applyQuantities(getPrefill(selectedSize));      } else if (prevSize === 6 && selectedSize === 12) {
        const doubled = {};
        Object.keys(prevQtys).forEach(function(k) { doubled[k] = prevQtys[k] * 2; });
        applyQuantities(doubled);
      } else if (prevSize === 12 && selectedSize === 6) {
        const halved = {};
        Object.keys(prevQtys).forEach(function(k) { halved[k] = Math.round(prevQtys[k] / 2); });
        applyQuantities(halved);
      } else {
applyQuantities(getPrefill(selectedSize));      }

      updateSizeCardImages();
      updateMeta();
      updateCTA();
      updateButtons();
    });
  });

  document.querySelectorAll('.bb-flavour-card:not(.bb-flavour-card--locked)').forEach(function(card) {
    const flavour = card.dataset.flavour;
    quantities[flavour] = 0;
    const minusBtn = card.querySelector('.bb-minus');
    const plusBtn = card.querySelector('.bb-plus');
    const numEl = card.querySelector('.bb-qty-num');

    minusBtn.addEventListener('click', function() {
      if (quantities[flavour] > 0) {
        userHasAdjusted = true;
        quantities[flavour]--;
        numEl.textContent = quantities[flavour];
        card.classList.toggle('has-quantity', quantities[flavour] > 0);
        updateMeta(); updateButtons(); updateCTA();
        window.bbTrack && bbTrack('flavour', 'remove', flavour);   // Journey Intelligence (flavour name = behavioural)
      }
    });

    plusBtn.addEventListener('click', function() {
      if (getTotalSelected() < selectedSize) {
        userHasAdjusted = true;
        quantities[flavour]++;
        numEl.textContent = quantities[flavour];
        card.classList.add('has-quantity');
        updateMeta(); updateButtons(); updateCTA();
        bbBuilderStart();                                            // fires once — first active build interaction
        window.bbTrack && bbTrack('flavour', 'add', flavour);       // Journey Intelligence (flavour name = behavioural)
      }
    });
  });

var KLAVIYO_PUBLIC_KEY = 'XB9FWQ';
  var KLAVIYO_LIST_ID = 'Wd6gHg';
  var KLAVIYO_OFFWEEK_LIST_ID = 'YuJue2';
  var SPECIAL_STORAGE_KEY = 'bb_special_unlocked';

  function unlockSpecial(saveToStorage) {
  if (saveToStorage !== false) {
    try { localStorage.setItem(SPECIAL_STORAGE_KEY, '1'); } catch(e) {}
  }

  const card = document.getElementById('bb-special-card');
  if (!card) return;

  const mode = card.dataset.mode;
  const offweekCard = document.getElementById('bb-special-offweek');
  const unlock = document.getElementById('bb-special-unlock');

  // If we're in off-week reward mode, hide the off-week card and reveal the special
  if (mode === 'offweek-reward' && offweekCard) {
    offweekCard.style.display = 'none';
    card.style.display = '';
  }

  // Standard unlock behaviour: remove locked state and hide email box
  card.classList.remove('bb-flavour-card--locked');
  if (unlock) unlock.style.display = 'none';

  // Wire up the special card's qty buttons
  const flavour = card.dataset.flavour;
  quantities[flavour] = 0;
  const minusBtn = card.querySelector('.bb-minus');
  const plusBtn = card.querySelector('.bb-plus');
  const numEl = card.querySelector('.bb-qty-num');

  minusBtn.addEventListener('click', function() {
    if (quantities[flavour] > 0) {
      userHasAdjusted = true;
      quantities[flavour]--;
      numEl.textContent = quantities[flavour];
      card.classList.toggle('has-quantity', quantities[flavour] > 0);
      updateMeta(); updateButtons(); updateCTA();
    }
  });
  plusBtn.addEventListener('click', function() {
    if (getTotalSelected() < selectedSize) {
      userHasAdjusted = true;
      quantities[flavour]++;
      numEl.textContent = quantities[flavour];
      card.classList.add('has-quantity');
      updateMeta(); updateButtons(); updateCTA();
    } else {
      // Box already full (Barney 2026-08-24): explain why + did nothing — brown note just
      // beneath the flavour cards. Cleared when a bar is removed (updateMeta) or after 7s.
      var n = document.getElementById('bb-special-full-note');
      if (!n) {
        // Desktop sizes up to 2.1rem (Barney 2026-08-24) — needs a stylesheet rule since the
        // inline 12px can't carry a media query; !important outranks the inline style.
        if (!document.getElementById('bb-special-note-css')) {
          var _st = document.createElement('style');
          _st.id = 'bb-special-note-css';
          _st.textContent = '@media (min-width: 750px){ #bb-special-full-note { font-size: 2.1rem !important; } #bb-bars-short-note { font-size: 2rem !important; } }';
          document.head.appendChild(_st);
        }
        var grid = document.getElementById('bb-flavour-grid');
        if (grid && grid.parentNode) {
          n = document.createElement('div');
          n.id = 'bb-special-full-note';
          n.style.cssText = "display:none;margin:10px 0 2px;text-align:center;font-family:'Sackers Gothic Std',sans-serif;font-size:12px;letter-spacing:0.04em;color:#4B2E05;line-height:1.5;";
          grid.parentNode.insertBefore(n, grid.nextSibling);
        }
      }
      if (n) {
        n.innerHTML = 'Remove one bar of another flavour<br>to add the special';
        n.style.display = 'block';   // persists until a bar is removed (cleared in updateMeta)
      }
    }
  });
}

  window.unlockSpecial = unlockSpecial;


(function() {
  var params = new URLSearchParams(window.location.search);
  var fromNewsletter = params.get('special') === 'unlocked';
  var cached = false;
  try { cached = localStorage.getItem(SPECIAL_STORAGE_KEY) === '1'; } catch(e) {}

  // Read current state from snippet marker
  var stateMarker = document.getElementById('bb-special-state-marker');
  var currentState = stateMarker ? stateMarker.dataset.state : 'public';

  // NOTE: don't clear localStorage synchronously off the baked marker — the runtime fetch reconciles
  // it via bbApplySpecialState (off/game-only clears it; public honours it), so a cached unlock isn't
  // wiped before the dashboard's real state is known.
  // Only honour unlock synchronously in 'public' state (the fetch re-runs this for the async case).
  if (currentState === 'public' && (fromNewsletter || cached)) {
    unlockSpecial(fromNewsletter);
  }
})();

  // ─── SPECIAL CARD LISTENERS (guarded — card may be disabled in snippet) ─────
  var specialCardEl = document.getElementById('bb-special-card');
  if (specialCardEl) {
    specialCardEl.addEventListener('click', function() {
      const emailEl = document.getElementById('bb-special-email');
      if (!emailEl) return;
      emailEl.classList.remove('bb-special-email--flash');
      void emailEl.offsetWidth;
      emailEl.classList.add('bb-special-email--flash');
      emailEl.focus();
    });
  }

var specialSubmitEl = document.getElementById('bb-special-submit');
  if (specialSubmitEl) {
    specialSubmitEl.addEventListener('click', function() {
      const email = document.getElementById('bb-special-email').value.trim();
      const errorEl = document.getElementById('bb-special-error');
      errorEl.textContent = '';
if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
    errorEl.textContent = 'Please enter a valid email address';
    return;
}

      // Remember the email (consented via this Klaviyo subscribe) so the personaliser logger can
      // attach it to the Airtable brief (A) and sync the draft to this Klaviyo profile (B).
      window.bbEmail = email;
      try { localStorage.setItem('bb_email', email); } catch (e) {}

      const btn = document.getElementById('bb-special-submit');
      btn.textContent = '...';
      btn.disabled = true;
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY, {
        method: 'POST',
        headers: { 'content-type': 'application/json', 'revision': '2023-12-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    properties: (function() {
                      var props = {};
                      var params = new URLSearchParams(window.location.search);
                      var ad = params.get('ad') || (window.bbActiveAdKey ? window.bbActiveAdKey() : sessionStorage.getItem('bb_ad')) || '';
                      var utmCampaign = params.get('utm_campaign') || sessionStorage.getItem('bb_utm_campaign') || localStorage.getItem('bb_utm_campaign') || '';
                      var utmContent = params.get('utm_content') || sessionStorage.getItem('bb_utm_content') || localStorage.getItem('bb_utm_content') || '';
                      var utmSource = params.get('utm_source') || sessionStorage.getItem('bb_utm_source') || localStorage.getItem('bb_utm_source') || '';
                      if (ad) props['Ad Variant'] = ad;
                      if (utmCampaign) props['Ad Campaign'] = utmCampaign;
                      if (utmContent) props['Ad Content'] = utmContent;
                      if (utmSource) props['Ad Source'] = utmSource;
                      props['Signup Source'] = 'Build a Box Special';
                      return props;
                    })()
                  }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } }
          }
        })
      })
      .then(function() {
        if (typeof fbq !== 'undefined' && email) {
          fbq('init', '1763916067609791', { em: email });
        }
        if (typeof fbq !== 'undefined') {
          fbq('track', 'Lead', {
            value: 10.00,
            currency: 'GBP',
            content_name: 'Build a Box Email Signup',
            content_category: 'Email Capture'
          });
        }
        unlockSpecial(true);
      })
      .catch(function() {
        if (typeof fbq !== 'undefined') {
          fbq('track', 'Lead', {
            value: 10.00,
            currency: 'GBP',
            content_name: 'Build a Box Email Signup',
            content_category: 'Email Capture'
          });
        }
        unlockSpecial(true);
      });
    });
  }

  var specialEmailEl = document.getElementById('bb-special-email');
  if (specialEmailEl) {
    specialEmailEl.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        var sb = document.getElementById('bb-special-submit');
        if (sb) sb.click();
      }
    });
  }

  // ─── OFF-WEEK CLUE SIGNUP — DISABLED ──────────────
  // The clue/email-signup mechanic was removed. Kept for future re-enable.
  // To restore: uncomment this block AND uncomment the off-week markup
  // in special-bar-blur-email.liquid snippet.
  /*
var OFFWEEK_STORAGE_KEY = 'bb_offweek_clue_unlocked';

  var offweekRoot     = document.getElementById('bb-special-offweek');
  var offweekSignup   = offweekRoot && offweekRoot.querySelector('[data-step="signup"]');
  var offweekClueStep = offweekRoot && offweekRoot.querySelector('[data-step="clue"]');
var offweekEmailEl  = document.getElementById('bb-offweek-email');
var offweekSubmitEl = document.getElementById('bb-offweek-submit');
var offweekErrorEl  = document.getElementById('bb-offweek-error');

  function showOffweekClue(saveToStorage) {
    if (saveToStorage !== false) {
      try { localStorage.setItem(OFFWEEK_STORAGE_KEY, '1'); } catch(e) {}
    }
    if (offweekRoot) offweekRoot.dataset.state = 'clue';

    // If we're restoring from localStorage on page load, skip the
    // animation and just swap. Otherwise, fade out signup, fade in clue.
    var animate = saveToStorage !== false;

    if (!animate) {
      if (offweekSignup)   offweekSignup.hidden = true;
      if (offweekClueStep) offweekClueStep.hidden = false;
      return;
    }

    if (offweekSignup) {
      offweekSignup.classList.add('bb-fade-out');
    }
    if (offweekClueStep) {
      offweekClueStep.hidden = false;
      offweekClueStep.classList.add('bb-fade-in');
    }
    setTimeout(function() {
      if (offweekSignup) offweekSignup.hidden = true;
    }, 300);
  }

  if (offweekRoot) {
    // Returning visitors who've already signed up skip straight to the clue
    try {
      if (localStorage.getItem(OFFWEEK_STORAGE_KEY) === '1') {
        showOffweekClue(false);
      }
    } catch(e) {}
  }

  if (offweekSubmitEl) {
    offweekSubmitEl.addEventListener('click', function() {
      var email = offweekEmailEl.value.trim();
      if (offweekErrorEl) offweekErrorEl.textContent = '';

      var allowedDomains = ['gmail.com','googlemail.com','yahoo.com','yahoo.co.uk','hotmail.com','hotmail.co.uk','outlook.com','live.com','live.co.uk','icloud.com','me.com','aol.com','aol.co.uk','msn.com','btinternet.com','sky.com','virginmedia.com','talktalk.net','mail.com','protonmail.com','zoho.com'];
      if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        if (offweekErrorEl) offweekErrorEl.textContent = 'Please enter a valid email address';
        return;
      }
      var domain = email.split('@')[1].toLowerCase();
      if (allowedDomains.indexOf(domain) === -1) {
        if (offweekErrorEl) offweekErrorEl.textContent = 'Please use a personal email address (e.g. Gmail, Yahoo, Outlook)';
        return;
      }

      offweekSubmitEl.textContent = '...';
      offweekSubmitEl.disabled = true;

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY, {
        method: 'POST',
        headers: { 'content-type': 'application/json', 'revision': '2023-12-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    properties: (function() {
                      var props = {};
                      var params = new URLSearchParams(window.location.search);
                      var ad = params.get('ad') || (window.bbActiveAdKey ? window.bbActiveAdKey() : sessionStorage.getItem('bb_ad')) || '';
                      var utmCampaign = params.get('utm_campaign') || sessionStorage.getItem('bb_utm_campaign') || localStorage.getItem('bb_utm_campaign') || '';
                      var utmContent = params.get('utm_content') || sessionStorage.getItem('bb_utm_content') || localStorage.getItem('bb_utm_content') || '';
                      var utmSource = params.get('utm_source') || sessionStorage.getItem('bb_utm_source') || localStorage.getItem('bb_utm_source') || '';
                      if (ad) props['Ad Variant'] = ad;
                      if (utmCampaign) props['Ad Campaign'] = utmCampaign;
                      if (utmContent) props['Ad Content'] = utmContent;
                      if (utmSource) props['Ad Source'] = utmSource;
                      props['Signup Source'] = 'Build a Box Off-Week Clue';
                      return props;
                    })()
                  }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: KLAVIYO_OFFWEEK_LIST_ID } } }
          }
        })
      })
      .then(function() {
        if (typeof fbq !== 'undefined' && email) {
          fbq('init', '1763916067609791', { em: email });
        }
        if (typeof fbq !== 'undefined') {
          fbq('track', 'Lead', {
            value: 10.00,
            currency: 'GBP',
            content_name: 'Build a Box Off-Week Clue Signup',
            content_category: 'Email Capture'
          });
        }
        showOffweekClue(true);
      })
      .catch(function() {
        if (typeof fbq !== 'undefined') {
          fbq('track', 'Lead', {
            value: 10.00,
            currency: 'GBP',
            content_name: 'Build a Box Off-Week Clue Signup',
            content_category: 'Email Capture'
          });
        }
        showOffweekClue(true);
      });
    });
  }

  if (offweekEmailEl) {
    offweekEmailEl.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        if (offweekSubmitEl) offweekSubmitEl.click();
      }
    });
  }

  if (offweekEmailEl) {
    offweekEmailEl.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        if (offweekSubmitEl) offweekSubmitEl.click();
      }
    });
  }
  */
  // ─── END OFF-WEEK CLUE SIGNUP — DISABLED ──────────

  function getTotalSelected() {
    return Object.values(quantities).reduce(function(a, b) { return a + b; }, 0);
  }

  function updateMeta() {
    const total = getTotalSelected();
    const countEl = document.getElementById('bb-progress-count');
    countEl.textContent = total + ' / ' + selectedSize;
    countEl.style.color = total === selectedSize ? '#4B2E05' : '';
    document.getElementById('bb-progress-fill').style.width = Math.min((total / selectedSize) * 100, 100) + '%';
    // Box of 12 → the 6 entries repeat twice; reveals the "two complete sets" copy.
    var mbPanel = document.getElementById('bb-remember-when-panel');
    if (mbPanel) mbPanel.classList.toggle('is-box12', selectedSize === 12);
    // Under-filled box note (Barney 2026-08-24): red line beneath Add to bag while the box
    // holds fewer bars than its size, so the dimmed button explains itself.
    var shortNote = document.getElementById('bb-bars-short-note');
    if (!shortNote) {
      var _addBtn = document.getElementById('bb-add-btn');
      if (_addBtn && _addBtn.parentNode) {
        if (!document.getElementById('bb-special-note-css')) {
          var _st2 = document.createElement('style');
          _st2.id = 'bb-special-note-css';
          _st2.textContent = '@media (min-width: 750px){ #bb-special-full-note { font-size: 2.1rem !important; } #bb-bars-short-note { font-size: 2rem !important; } }';
          document.head.appendChild(_st2);
        }
        shortNote = document.createElement('div');
        shortNote.id = 'bb-bars-short-note';
        shortNote.style.cssText = "display:none;width:100%;margin:10px auto 2px;text-align:center;font-family:'Sackers Gothic Std',sans-serif;font-size:12px;letter-spacing:0.04em;color:#b3261e;line-height:1.5;";
        _addBtn.parentNode.insertBefore(shortNote, _addBtn.nextSibling);
      }
    }
    // Box no longer full → the "remove one to add the special" nudge is resolved.
    if (total < selectedSize) {
      var _sfn = document.getElementById('bb-special-full-note');
      if (_sfn) _sfn.style.display = 'none';
    }
    if (shortNote) {
      // Desktop: the note displays IN PLACE of the express (shop) button above Add to bag
      // (Barney 2026-08-24) — that slot is empty while the box is short since showExpress
      // hides the button and the OR divider. Mobile keeps it beneath Add to bag.
      var _deskNote = window.matchMedia && matchMedia('(min-width: 750px)').matches;
      var _exWrap = document.getElementById('bb-express-wrap');
      var _atc = document.getElementById('bb-add-btn');
      if (_deskNote && _exWrap) {
        if (shortNote.parentNode !== _exWrap) _exWrap.appendChild(shortNote);
      } else if (_atc && _atc.parentNode && shortNote.parentNode !== _atc.parentNode) {
        _atc.parentNode.insertBefore(shortNote, _atc.nextSibling);
      }
      if (total < selectedSize) {
        var _rem = selectedSize - total;
        shortNote.innerHTML = 'Only ' + total + ' out of ' + selectedSize + ' bars selected<br>add ' + _rem + (_rem === 1 ? ' bar' : ' bars') + ' to complete your purchase';
        if (shortNote.style.display !== 'block') {
          shortNote.style.display = 'block';
          if (_deskNote) {   // desktop: fade in smoothly (Barney 2026-08-24); forced reflow commits the 0 start
            shortNote.style.opacity = '0';
            void shortNote.offsetHeight;
            shortNote.style.transition = 'opacity .45s ease';
            shortNote.style.opacity = '1';
            setTimeout(function () { shortNote.style.transition = ''; shortNote.style.opacity = ''; }, 520);
          }
        }
      } else {
        shortNote.style.display = 'none';
      }
    }
  }

  // A personaliser option is selected but its inputs are empty → block checkout.
  function personalisationIncomplete() {
    // Gifting message-first flow: completeness = the message(s) are filled (date/name optional).
    if (document.querySelector('.bb-page--gifting')) {
      return window.bbGiftPersoIncomplete ? window.bbGiftPersoIncomplete() : false;
    }
    var sel = document.querySelector('.bb-opt2-card.is-selected');
    if (!sel) return false;   // no personalisation chosen → plain box, fine
    var opt = sel.dataset.opt2;
    function has(id) { var el = document.getElementById(id); return !!(el && (el.value || '').trim()); }
    // Use each mode's completeness check (requires EVERY row filled for the 6-of-each
    // modes); fall back to the hidden-input check if the helper isn't ready yet.
    if (opt === 'date')    return !(window.bbDatesComplete    ? window.bbDatesComplete()    : (has('mb-top-input') && has('mb-bottom-input')));
    if (opt === 'name')    return !(window.bbNamesComplete    ? window.bbNamesComplete()    : (has('mb-name-input') && has('mb-anecdote-input')));
    if (opt === 'chapter') return !(window.bbChaptersComplete ? window.bbChaptersComplete() : has('mb-chapters-input'));
    return false;
  }
  function personalisationErrorMsg() {
    var sel = document.querySelector('.bb-opt2-card.is-selected');
    var opt = sel ? sel.dataset.opt2 : '';
    if (opt === 'date')    return 'Please add your date before checking out.';
    if (opt === 'name')    return 'Please add your name before checking out.';
    if (opt === 'chapter') return 'Please add your story before checking out.';
    return 'Please complete your personalisation before checking out.';
  }

  // Show/hide the "finish your personalisation" notice. Shown on the add-to-bag CLICK
  // (not proactively); hidden as soon as the personalisation is complete.
  function setPersoNotice(show) {
    var notice = document.getElementById('bb-perso-notice');
    if (!notice) return;
    if (show && personalisationIncomplete()) {
      var sel = document.querySelector('.bb-opt2-card.is-selected');
      var opt = sel ? sel.dataset.opt2 : '';
      var what = opt === 'name' ? 'names and messages' : (opt === 'chapter' ? 'story' : 'dates and messages');
      var msg = document.getElementById('bb-perso-notice-msg');
      if (msg) msg.textContent = 'To proceed to checkout please finish entering your ' + what + '.';
      notice.hidden = false;
    } else {
      notice.hidden = true;
    }
  }
  (function () {
    var skip = document.getElementById('bb-perso-notice-skip');
    if (skip) skip.addEventListener('click', function () {
      if (window.bbKeepClassic) window.bbKeepClassic();   // deselect → plain classic box
      var p2 = document.getElementById('bb-option-2'); if (p2) p2.classList.remove('bb-opt2--activated');
      if (typeof updateButtons === 'function') updateButtons();
    });
    // Tapping the express buttons while personalisation is incomplete → show the message.
    var block = document.getElementById('bb-express-block');
    if (block) block.addEventListener('click', function () {
      setPersoNotice(true);
      var _p = document.getElementById('bb-option-2') || document.getElementById('bb-personalise-collapse');
      if (_p && _p.scrollIntoView) _p.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  })();

  // Layer 1 — client-side profanity guard: scan the personalisation inputs so offensive text
  // can't be added to the cart. (The AI path is also moderated server-side in story-ideas.)
  function personalisationHasProfanity() {
    if (!window.bbHasProfanity) return false;
    var vals = [];
    var panel = document.getElementById('bb-remember-when-panel');
    if (panel) [].forEach.call(panel.querySelectorAll('input[type="text"], textarea'), function (el) {
      // Skip the masked date fields (never a language risk).
      if (el.value && !el.classList.contains('mb-first-date') && !el.classList.contains('mb-drow-date')) vals.push(el.value);
    });
    ['mb-names-input', 'mb-dates-input', 'mb-top-input', 'mb-bottom-input', 'mb-name-input', 'mb-anecdote-input'].forEach(function (id) {
      var el = document.getElementById(id); if (el && el.value) vals.push(el.value);
    });
    return window.bbAnyProfanity(vals);
  }

  function updateButtons() {
    const total = getTotalSelected();
    document.querySelectorAll('.bb-flavour-card:not(.bb-flavour-card--locked)').forEach(function(card) {
      const flavour = card.dataset.flavour;
      // The special's + stays CLICKABLE at a full box (Barney 2026-08-24) — its handler shows
      // the "Remove one of another flavour" note instead of adding; a disabled button would
      // swallow the click and the note could never appear.
      card.querySelector('.bb-plus').disabled = total >= selectedSize && card.id !== 'bb-special-card';
      card.querySelector('.bb-minus').disabled = quantities[flavour] === 0;
    });
    const barsComplete = total === selectedSize;
    const persoOk = !personalisationIncomplete();
    // Add-to-bag stays clickable once the bars are chosen; the empty-personalisation case
    // is caught on click (the notice is shown then). Express requires both.
    // Layer 1 — offensive language blocks checkout (add + express) until it's reworded.
    const bad = personalisationHasProfanity();
    document.getElementById('bb-add-btn').disabled = !barsComplete || bad;
    // Express shows whenever the bars are chosen; while personalisation is incomplete OR
    // contains offensive language it's covered by a transparent click-catcher (bb-express-block).
    var showExpress = barsComplete;
    document.getElementById('bb-express-checkout').style.display = showExpress ? 'block' : 'none';
    var _orEl = document.getElementById('bb-or');
    if (_orEl) {
      if (showExpress) { _orEl.style.display = 'flex'; _orEl.classList.remove('bb-or--line'); }
      else if (window.matchMedia && matchMedia('(min-width: 750px)').matches) {
        // Error state on desktop (Barney 2026-08-24): keep the divider but as a continuous
        // line — the OR word only makes sense between two live buttons.
        _orEl.style.display = 'flex'; _orEl.classList.add('bb-or--line');
      } else { _orEl.style.display = 'none'; }
    }
    var _block = document.getElementById('bb-express-block'); if (_block) _block.hidden = !(showExpress && (!persoOk || bad));
    // Show the profanity notice while bad; otherwise clear the error once personalisation is filled.
    if (bad) { var _eb = document.getElementById('bb-error'); if (_eb) _eb.textContent = 'Please reword — that language can’t be printed on a bar.'; try { window.bbTrack && bbTrack('error', 'validate_language'); } catch (e9) {} }
    else if (persoOk) { var _e = document.getElementById('bb-error'); if (_e) _e.textContent = ''; setPersoNotice(false); }
    if (showExpress) {
      var expressDiv = document.getElementById('bb-express-checkout');
      if (expressDiv && !expressDiv._trackingAdded) {
        expressDiv.addEventListener('click', trackExpressCheckout);
        expressDiv._trackingAdded = true;
      }
    }
  }

  function updateCTA() {
    const btnText = document.getElementById('bb-add-btn-text');
    if (btnText) btnText.textContent = 'Add to bag – £' + effectivePrice().toFixed(2);
    const subline = document.getElementById('bb-add-btn-subline');
    if (subline) subline.textContent = (effectivePrice() >= 30) ? 'Free delivery ✓' : '';
    syncForm();
  }
  window.bbUpdateButtons = function () { if (typeof updateButtons === 'function') updateButtons(); };
  // Called by the Step 3 toggle whenever the story selection changes
  window.bbRefreshForStory = function() {
    // RE-ENTRANCY GUARD: applyStoryPricing/applyNamesPricing now call this on EVERY invocation (so the
    // CTA reprices as content arrives), and writeProps → applyStoryPricing runs inside syncForm's
    // serialise-nets — without the guard that cycle recursed forever (page froze to the browser's
    // "wait/kill" dialog when an ad config selected a story with empty props). One refresh per frame.
    if (window.__bbRefreshingStory) return;
    window.__bbRefreshingStory = true;
    try {
      syncForm();   // push the story-override variant into the hidden #id input (price/title were going stale)
      updateCTA();
      if (typeof updateButtons === 'function') updateButtons();
      refreshDelivery();
    } finally { window.__bbRefreshingStory = false; }
  };

function syncForm() {
  const step1Parts = [];
  Object.entries(quantities).forEach(function(entry) {
    if (entry[1] > 0) step1Parts.push(entry[1] + 'x ' + entry[0]);
  });
  const variantInput = document.getElementById('bb-variant-input');
  const step1Input = document.getElementById('bb-step1-input');
  const boxsizeInput = document.getElementById('bb-boxsize-input');
  const storyInput = document.getElementById('bb-story-input');
  if (variantInput) variantInput.value = effectiveVariant();
  if (step1Input) step1Input.value = step1Parts.join(', ');
  if (boxsizeInput) boxsizeInput.value = selectedSize;
  // Safety net for a SINGLE name-on-top box: mb-name-input/mb-anecdote-input are written by several
  // controllers (message-first #mb-first-name, Names-persona #mb-name-line, the render sync) which can
  // race and momentarily blank the hidden input. When the chosen story is a single 'Names' box, re-derive
  // both from whichever source field holds a value so the submitted _Name is never empty (cart would show
  // the "Name" placeholder). Skipped for per-bar/six (namesPerBar/sixDates own their own props).
  (function () {
    var _st = window.bbStoryState || {};
    if (_st.story !== 'Names' || _st.namesPerBar || _st.sixDates) return;
    var nameH = document.getElementById('mb-name-input');
    var anecH = document.getElementById('mb-anecdote-input');
    var fn = document.getElementById('mb-first-name');
    var nl = document.getElementById('mb-name-line');
    var al = document.getElementById('mb-anecdote-line');
    var fo = document.getElementById('mb-first-occasion');
    var nameVal = ((nameH && nameH.value) || (fn && fn.value) || (nl && nl.value) || '').trim();
    var anecVal = ((anecH && anecH.value) || (al && al.value) || (fo && fo.value) || '').trim();
    if (nameH && nameVal) nameH.value = window.bbCpSlice(nameVal, 10);
    if (anecH && anecVal) anecH.value = window.bbCpSlice(anecVal, 20);
  })();
  // Memory-mode net (dates + six-unique): a story is selected — the personalised variant will be
  // charged — but EVERY memory-mode content prop is empty (a late mode flip cleared them). Re-serialise
  // from the in-memory model via the mode-aware writer; writeProps guards all its own branches, so if the
  // model is genuinely empty it correctly clears the story instead. Chapters has its own writer (skipped).
  try {
    var _stM = window.bbStoryState || {};
    if ((_stM.story === 'Remember when' || _stM.story === 'Names') && window.bbSyncPersoProps) {
      var _ids = ['mb-top-input','mb-bottom-input','mb-dates-input','mb-names-input','mb-name-input','mb-anecdote-input'];
      var _any = _ids.some(function (id) { var el = document.getElementById(id); return !!(el && (el.value || '').trim()); });
      if (!_any) window.bbSyncPersoProps();
    }
  } catch (e) {}
  // Same net for PER-BAR names: story says Names-per-bar but the hidden _Names is empty (cleared by a
  // mode switch and never rewritten) → rebuild it from the entries[] model so the paid Names variant
  // always carries its names.
  try {
    var _stN = window.bbStoryState || {};
    if (_stN.story === 'Names' && _stN.namesPerBar && window.bbNamesResync) {
      var _nmH = document.getElementById('mb-names-input');
      if (_nmH && !(_nmH.value || '').trim()) window.bbNamesResync();
    }
  } catch (e) {}
  // Stamp the loop-type router (_Add your story) from the chosen story so the print dashboard
  // can classify the order without hitting Airtable — but ONLY when there's actual personalisation
  // CONTENT. Selecting a format (or a default "A Date" pre-selection) must never alone write the
  // property, or plain flavour-only boxes arrive mis-tagged "Remember when" with nothing to print.
  // (Pricing/variant stays tied to selection via bbStoryState.story — this decouples only the
  // submitted property.) Content IDs = the theme's canonical personalisation-content set.
  var _persoContentIds = ['mb-top-input', 'mb-bottom-input', 'mb-dates-input', 'mb-name-input', 'mb-anecdote-input', 'mb-names-input', 'mb-chapters-input'];
  var _hasPersoContent = _persoContentIds.some(function (id) { var el = document.getElementById(id); return !!(el && (el.value || '').trim()); });
  // Value is 'Remember when' | 'Names' | 'Tell a story' (or '' when not personalised / no content).
  if (storyInput) storyInput.value = (_hasPersoContent && window.bbStoryState && window.bbStoryState.story) || '';
  // Plain vs personalised router for the print dashboard. No personalisation loop selected
  // (empty story state) → 'plain': flavours only, each flavour prints its own branded logo.
  // A Shopify Flow converts _box_type=plain into the order tag `plain-box`.
  const boxtypeInput = document.getElementById('bb-boxtype-input');
  if (boxtypeInput) boxtypeInput.value = ((window.bbStoryState && window.bbStoryState.story) ? 'personalised' : 'plain');
  updatePersoStateSub();   // build-your-box "No personalisation added" / "Personalisation added +£X remove"
}


// ─── FORM SUBMIT — fire tracking then submit ─────
  var bbSubmitting = false;
  document.getElementById('bb-product-form').addEventListener('submit', function(e) {
    e.preventDefault();
    if (bbSubmitting) return;   // guard against double-click / double Enter adding the box twice
    // Block add-to-bag when a personaliser option is selected but its inputs are empty —
    // show the message now (on click) and scroll to the personaliser.
    if (personalisationIncomplete()) {
      if (document.querySelector('.bb-page--gifting')) {
        // Gifting: inline red error under the message(s) + scroll there (no notice above the button).
        if (window.bbShowGiftPersoError) window.bbShowGiftPersoError(true);
        var _ge = document.getElementById('mb-gift-msg-error');
        if (_ge && _ge.scrollIntoView) _ge.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        setPersoNotice(true);
        var _p = document.getElementById('bb-option-2') || document.getElementById('bb-personalise-collapse');
        if (_p && _p.scrollIntoView) _p.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }
    bbSubmitting = true;
    var _addBtn = document.getElementById('bb-add-btn');
    if (_addBtn) _addBtn.disabled = true;
    syncForm();   // guarantee the hidden #id = current story-override variant before submit
    trackBabAddToCart();
    bbCheckoutReached();   // Journey Intelligence: reached checkout + personalise done/skipped
    // Personalisation funnel: COMPLETED — valid personalisation is active (priced into the variant) at
    // add-to-cart. storyOverride() is non-null only when the personaliser is open AND has content, so a
    // skipped/removed/empty box never counts. Cleanest attachment-rate signal.
    if (storyOverride() && window.bbPersoTrack) window.bbPersoTrack('personalisation_completed', { price: effectivePrice() });
    // CRM ingest (window.bbCrm, defined in journey-extra.js): the personaliser finish is an email-known
    // moment for logged-in customers (the helper resolves the email; guests quarantine server-side).
    if (storyOverride() && window.bbCrm) {
      window.bbCrm('personalisation.completed', { properties: { product: 'Build a Bar' } });
      // The AI "Tell a story" (chapters) mode IS the story builder → also emit story.completed.
      if (window.bbStoryState && window.bbStoryState.story === 'Tell a story') {
        window.bbCrm('story.completed', { properties: { product: 'Build a Bar' } });
      }
    }
    setTimeout(function() {
      bbAddToCart(e.target, _addBtn);
    }, 150);
  });

  // Back/forward-cache (bfcache) recovery. Adding to cart navigates to /cart (there is no cart drawer
  // yet), so the submit leaves bbSubmitting = true and #bb-add-btn disabled as the page unloads. When the
  // customer presses BACK, the browser restores the page from bfcache with that stale state FROZEN — so
  // `if (bbSubmitting) return;` swallows the next submit and the button is dead ("can't add to cart
  // again"). On a bfcache restore, clear the flag and re-validate the button so it works immediately.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    bbSubmitting = false;
    var _b = document.getElementById('bb-add-btn');
    if (_b) _b.disabled = false;
    if (window.bbUpdateButtons) window.bbUpdateButtons();   // recompute the correct enabled/disabled state
  });

  // Add the box via fetch and slide the cart drawer in (keeping every personalisation property).
  // Falls back to a normal cart-page submit if the drawer isn't on the page or the request fails.
  function bbAddToCart(form, addBtn) {
    // DEDUP guard shared with journey-extra (window.__bbA2Cts): two listeners can observe the same
    // physical add (double-submit race produced 2× checkout:add_to_cart in the funnel data). One report
    // per 1.5s window keeps the stats accurate while still counting genuine repeat adds.
    var _a2cNow = Date.now();
    if (!window.__bbA2Cts || _a2cNow - window.__bbA2Cts > 1500) {
      window.__bbA2Cts = _a2cNow;
      window.bbTrack && bbTrack('checkout', 'add_to_cart');   // checkout-path: real (natural) add-to-cart
      // Funnel CART stage (landed → builder → cart → checkout → purchase): fired once per successful add.
      var _btIn = document.getElementById('bb-boxtype-input');
      window.bbTrack && bbTrack('cart', (_btIn && _btIn.value) || '');
    }
    var drawer = document.querySelector('cart-drawer');
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    if (!drawer || typeof drawer.renderContents !== 'function') {
      // ECOMMERCE-ANALYTICS-THEME.md (2026-08-23): this native-submit path bypasses fetch, so the
      // global /cart/add tee in theme.liquid never sees BYB adds — beacon here instead
      // (sendBeacon survives the page unload). Variant → product-id map resolved 2026-08-23;
      // unmapped variants are skipped rather than sent with a wrong id.
      try {
        var _ecPids = {
          '52900084973904': [10460556099920, 'Your selection box'],
          '53400089592144': [10580469514576, 'Your personalised box'],
          '53223811842384': [10548681736528, 'Personalised box'],
          '53334210773328': [10548681736528, 'Personalised box']
        };
        var _ecV = (form.querySelector('input[name="id"], select[name="id"]') || {}).value;
        var _ecM = _ecPids[String(_ecV || '')];
        if (_ecM && navigator.sendBeacon) {
          var _ecQ = parseInt((form.querySelector('[name="quantity"]') || {}).value, 10) || 1;
          navigator.sendBeacon('https://barnabydashboard.netlify.app/.netlify/functions/ecommerce-analytics',
            new Blob([JSON.stringify({ pid: _ecM[0], title: _ecM[1], qty: _ecQ, vid: (function () { try { var v = localStorage.getItem('bb_vid'); if (!v) { v = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : ('v-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10)); localStorage.setItem('bb_vid', v); } return v; } catch (eV) { return null; } })() })], { type: 'text/plain' }));
        }
      } catch (eEc) {}
      // ATC-EVENTS HANDOFF (2026-08-25): the classic path was a NATIVE document POST — Shopify's
      // Web Pixels sandbox never observes a full-page form submission, so BYB adds (the main ad
      // destination) never generated AddToCart for Meta at all. Converted to a fetch add + a
      // 250ms-delayed redirect: the sandbox sees the cart mutation and both the pixel and CAPI
      // copies get out before navigation. 422 etc falls back to the native submit so Shopify's
      // own error page still shows. __bbEcTs stops the global tee double-counting the beacon
      // already sent above.
      window.__bbEcTs = Date.now();
      fetch(addUrl, { method: 'POST', headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function (resp) {
          if (!resp || resp.status) { form.submit(); return; }
          setTimeout(function () { window.location = cartUrl; }, 250);
        })
        .catch(function () { form.submit(); });
      return;
    }
    var fd = new FormData(form);   // includes id, quantity AND all properties[...] (personalisation)
    try {
      var ids = drawer.getSectionsToRender().map(function (s) { return s.id; });
      fd.append('sections', ids.join(','));
      fd.append('sections_url', window.location.pathname);
      if (drawer.setActiveElement) drawer.setActiveElement(document.activeElement);
    } catch (e2) {}
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (resp) {
        if (!resp || resp.status) { try { window.bbTrack && bbTrack('error', 'atc_fail'); } catch (e3) {} window.location = cartUrl; return; }   // 422 etc. → cart page
        // The <cart-drawer> element keeps the page-load `is-empty` class (renderContents only clears it
        // from .drawer__inner). If left on, open() looks for a non-existent .drawer__inner-empty and
        // trapFocus() throws on null — aborting the open and leaving the drawer blank. Clear it first.
        drawer.classList.remove('is-empty');
        drawer.renderContents(resp);   // paints the drawer sections + slides it open
        bbSubmitting = false;
        if (addBtn) addBtn.disabled = false;
      })
      .catch(function () { try { window.bbTrack && bbTrack('error', 'atc_fail'); } catch (e3) {} setTimeout(function () { window.location = cartUrl; }, 250); });
  }

  // Express / wallet checkout bypasses the form submit above. A click reaching
  // #bb-express-checkout means the real express button is active (the incomplete-
  // personalisation overlay intercepts otherwise), so count it as reached-checkout too.
  (function () {
    var exp = document.getElementById('bb-express-checkout');
    if (exp) exp.addEventListener('click', function () { bbCheckoutReached('express'); }, true);
  })();

  (function() {
    const params = new URLSearchParams(window.location.search);
    const sizeParam = params.get('size');
    const occasionParam = params.get('occasion');

    if (sizeParam === '12') {
      const card12 = document.querySelector('.bb-size-card[data-size="12"]');
      const card6 = document.querySelector('.bb-size-card[data-size="6"]');
      if (card12 && card6) {
        card6.classList.remove('selected');
        card12.classList.add('selected');
        selectedSize = 12;
        selectedPrice = BB_GIFTING ? GIFTING_BASE[12].price : 33.99;
        if (BB_GIFTING) selectedVariantId = GIFTING_BASE[12].variant;
      }
    }

    if (occasionParam && occasionVariants[occasionParam]) {
      selectedOccasion = occasionParam;
      const checkbox = document.getElementById('bb-gift-checkbox');
      const wrap = document.getElementById('bb-occasion-wrap');
      const giftWrap = document.getElementById('bb-gift-message-wrap');
      if (checkbox) checkbox.classList.add('checked');
      if (wrap) wrap.classList.add('visible');
      if (giftWrap) giftWrap.classList.add('visible');
      document.querySelectorAll('.bb-occasion-btn').forEach(function(b) {
        b.classList.toggle('selected', b.dataset.occasion === occasionParam);
      });
    }

    selectedVariantId = occasionVariants[selectedOccasion][selectedSize];
  })();

function applyDefaultPrefill() {
  userHasAdjusted = false;
  applyQuantities(getPrefill(selectedSize));
  updateMeta();
  updateButtons();
  updateCTA();
}
window.applyDefaultPrefill = applyDefaultPrefill;

// Newsletter unlock link (?special=unlocked): besides unlocking, put 1x special INTO the default
// box — one bar comes off the most-stocked default flavour so the box stays full. Skips silently
// if the special is still locked, already in the box, or the customer has built their own box.
function addSpecialToDefaultBox() {
  var card = document.getElementById('bb-special-card');
  if (!card || card.classList.contains('bb-flavour-card--locked')) return;
  var flavour = card.dataset.flavour;
  if (!flavour || userHasAdjusted || quantities[flavour]) return;
  var map = Object.assign({}, getPrefill(selectedSize));
  var donor = null, max = 0;
  for (var k in map) { if (map[k] > max) { max = map[k]; donor = k; } }
  if (donor) map[donor] = map[donor] - 1;
  map[flavour] = 1;
  applyQuantities(map);
  updateMeta(); updateButtons(); updateCTA();
}

// Called by the special-bar snippet's runtime fetch AFTER the box is built synchronously — so the
// dashboard's live state wins over the baked value even though the box was already prefilled. When
// the special is off / game-only: drop it from the box, hide+re-lock the card so it can't be added,
// clear the stale unlock flag, and recompute the default prefill so it's not pre-selected.
window.bbApplySpecialState = function (state) {
  if (state === 'public') {
    // Dashboard confirmed public — honour a cached/newsletter unlock that the synchronous pass
    // skipped (it ran before the fetch, while the baked fallback said 'off').
    try {
      var _nl = new URLSearchParams(window.location.search).get('special') === 'unlocked';
      var _ca = false; try { _ca = localStorage.getItem(SPECIAL_STORAGE_KEY) === '1'; } catch (e) {}
      if ((_nl || _ca) && typeof unlockSpecial === 'function') unlockSpecial(_nl);
      if (_nl) addSpecialToDefaultBox();   // the link also pre-adds it to the default box
    } catch (e) {}
    return;
  }
  var card = document.getElementById('bb-special-card');
  var specialName = card ? card.dataset.flavour : null;
  try { localStorage.removeItem(SPECIAL_STORAGE_KEY); } catch (e) {}
  if (specialName && quantities[specialName]) delete quantities[specialName];
  if (card) {
    card.style.display = 'none';
    card.classList.add('bb-flavour-card--locked');
    card.classList.remove('has-quantity');
    var n = card.querySelector('.bb-qty-num'); if (n) n.textContent = '0';
  }
  if (!userHasAdjusted) {
    applyDefaultPrefill();            // recompute the default box (no special) + repaint
  } else {
    updateMeta(); updateButtons(); updateCTA();   // keep the customer's box, just minus the special
  }
};

applyDefaultPrefill();
try {
  if (new URLSearchParams(window.location.search).get('special') === 'unlocked') addSpecialToDefaultBox();
} catch (e) {}
// FLAVOUR-CONFIG-THEME.md: adapt the default box + ad filler to the Ops → Bars lineup at
// runtime (window.bbFlavourConfig is set by the flavour-picker snippet; feed unreachable →
// today's hardcoded defaults stand). Mutates the prefill maps in place (they're consts).
(function () {
  if (!window.bbFlavourConfig) return;
  window.bbFlavourConfig.then(function (cfg) {
    if (!cfg || !Array.isArray(cfg.bybFlavours) || !cfg.bybFlavours.length) return;
    var byb = cfg.bybFlavours;
    AD_FILLER_ORDER = byb.slice();
    function adaptInPlace(map, size) {
      var total = 0, k;
      for (k in map) {
        if (byb.indexOf(k) < 0) { delete map[k]; }
        else { total += map[k]; }
      }
      var i = 0;
      while (total < size && byb.length) { var f = byb[i % byb.length]; map[f] = (map[f] || 0) + 1; total++; i++; }
      while (total > size) {                       // trim overshoot from the most-stocked flavour
        var donor = null, max = 0;
        for (k in map) { if (map[k] > max) { max = map[k]; donor = k; } }
        if (!donor) break;
        map[donor]--; if (!map[donor]) delete map[donor];
        total--;
      }
    }
    // Prefer the operator's defaultLineup verbatim (QA 2026-08-21: the hardcoded map had
    // given Caramel's slot to Chocolate Pretzel, so Orange never appeared in the default box —
    // adaptInPlace only fixes totals, not composition). Lineup missing → old adapt behaviour.
    function refillFromLineup(map, size) {
      var line = cfg.defaultLineup;
      if (!Array.isArray(line) || !line.length) { adaptInPlace(map, size); return; }
      var k; for (k in map) delete map[k];
      for (var j = 0; j < size; j++) { var fl = line[j % line.length]; map[fl] = (map[fl] || 0) + 1; }
    }
    refillFromLineup(defaultPrefill6, 6);
    refillFromLineup(defaultPrefill12, 12);
    if (!userHasAdjusted) applyDefaultPrefill();
  });
})();
updateSizeCardImages();
  updateMeta();
  updateCTA();
  updateButtons();
  updateGiftPlaceholder();
  trackBabViewItem();

  (function() {
    const cutoffHour = 11;
    const countdownStartHour = 6;
    const freeShippingThreshold = 30;
    const trackedDeliveryPrice = 2.95;

    function now() { return new Date(); }
    function isSunday(d) { return d === 0; }
    function isDispatchDay(d) { return d >= 1 && d <= 6; }

    function addDeliveryDays(date, days) {
      const result = new Date(date);
      while (days > 0) { result.setDate(result.getDate() + 1); if (result.getDay() !== 0) days--; }
      return result;
    }

    function nextDispatchDay(date) {
      const result = new Date(date);
      do { result.setDate(result.getDate() + 1); } while (!isDispatchDay(result.getDay()));
      return result;
    }

    function getDispatchDate(d) {
      const day = d.getDay(), hour = d.getHours();
      if (isSunday(day)) return nextDispatchDay(d);
      if (isDispatchDay(day) && hour < cutoffHour) return new Date(d);
      return nextDispatchDay(d);
    }

    function weekdayShort(d) { return ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][d.getDay()]; }

    function shouldShowCountdown(d) {
      return isDispatchDay(d.getDay()) && d.getHours() >= countdownStartHour && d.getHours() < cutoffHour;
    }

    function formatCountdown(ms) {
      const totalMinutes = Math.max(0, Math.floor(ms / 60000));
      return Math.floor(totalMinutes / 60) + 'hrs ' + String(totalMinutes % 60).padStart(2, '0') + 'mins';
    }

    function renderDelivery(productPrice) {
      const d = now();
      let dispatch = getDispatchDate(d);
      // Personalised (printed) loops need an extra working day to print.
      if (window.bbStoryState && window.bbStoryState.story) dispatch = nextDispatchDay(dispatch);
      const deliveryStart = addDeliveryDays(dispatch, 1);
      const deliveryEnd = addDeliveryDays(dispatch, 2);
      const rangeEl = document.getElementById('bb-cart-range');
      const countdownEl = document.getElementById('bb-cart-countdown');
      const rateEl = document.getElementById('bb-cart-delivery-rate');
      const freeEl = document.getElementById('bb-cart-delivery-free');

      if (rangeEl) rangeEl.textContent = 'Arrives ' + weekdayShort(deliveryStart) + '–' + weekdayShort(deliveryEnd);
      if (countdownEl) {
        // Hide the "Order within…" urgency line for personalised boxes (they need the extra
        // printing day, so a same-day cutoff would mislead) and on the gifting page.
        var isPersonalised = !!(window.bbStoryState && window.bbStoryState.story);
        var isGifting = !!document.querySelector('.bb-page--giftpage');
        if (shouldShowCountdown(d) && !isPersonalised && !isGifting) {
          const cutoff = new Date(d); cutoff.setHours(cutoffHour, 0, 0, 0);
          countdownEl.style.display = '';
          countdownEl.textContent = 'Order within ' + formatCountdown(cutoff - d);
        } else { countdownEl.style.display = 'none'; countdownEl.textContent = ''; }
      }
      if (typeof productPrice === 'number' && productPrice >= freeShippingThreshold) {
        if (rateEl) { rateEl.style.display = ''; rateEl.textContent = 'Free delivery'; }
        if (freeEl) freeEl.style.display = 'none';
      } else {
        if (rateEl) { rateEl.style.display = ''; rateEl.textContent = 'Tracked delivery £' + trackedDeliveryPrice.toFixed(2); }
        if (freeEl) { freeEl.style.display = ''; freeEl.textContent = 'Free delivery on orders over £' + freeShippingThreshold; }
      }
    }

    refreshDelivery = function() { renderDelivery(effectivePrice()); };
    refreshDelivery();
    setInterval(function() { renderDelivery(effectivePrice()); }, 30000);
    document.querySelectorAll('.bb-size-card').forEach(function(el) {
      el.addEventListener('click', function() { setTimeout(function() { renderDelivery(effectivePrice()); }, 50); });
    });
  })();

})();

// ─────────────────────────────────────────────────────────────────────────
// Step-3 personalisation engine (Moments/Dates, Names, Chapters, reveal) lives
// in the make-it-personal snippet's scripts + the IIFEs below.
// ─────────────────────────────────────────────────────────────────────────
(function () {
  var memoryMode = document.getElementById('mb-memory-mode');
  var occWrap    = document.getElementById('mb-occasions');
  var listWrap   = document.getElementById('mb-date-list');
  var addBtn     = document.getElementById('mb-date-add');
  var capNote    = document.getElementById('mb-date-cap');
  var tipBox     = document.getElementById('mb-tip');
  var footText   = document.getElementById('mb-foot-text');
  var occIcon    = document.getElementById('mb-occasion-icon');
  var occTitle   = document.getElementById('mb-occasion-title');
  var ideasHead  = document.getElementById('mb-occasion-ideas-head');
  var writeOwn   = document.getElementById('mb-occasion-write');
  var infoBox    = document.getElementById('mb-moment-info');
  var infoTitle  = document.getElementById('mb-moment-info-title');
  var infoSub    = document.getElementById('mb-moment-info-sub');
  var panel      = document.getElementById('bb-remember-when-panel');
  var barMap     = document.getElementById('mb-barmap');
  var tabDates    = document.getElementById('mb-tab-dates');
  var tabChapters = document.getElementById('mb-tab-chapters');
  var firstEntry  = document.getElementById('mb-first-entry');
  var firstDate   = document.getElementById('mb-first-date');
  var firstOcc    = document.getElementById('mb-first-occasion');
  var sixRow      = document.getElementById('mb-dates-six-row');
  var sixCheckbox = document.getElementById('mb-dates-six-checkbox');
  var sixWord     = document.getElementById('mb-dates-six-word');
  var datesFoot   = document.getElementById('mb-dates-foot');
  var datesFootNum = document.getElementById('mb-dates-foot-num');
  var overlayTop = document.getElementById('mb-preview-overlay-top');
  var overlayBot = document.getElementById('mb-preview-overlay-bottom');
  // existing hidden form inputs (unchanged in build-a-box.liquid)
  var topHidden    = document.getElementById('mb-top-input');
  var bottomHidden = document.getElementById('mb-bottom-input');
  var datesHidden  = document.getElementById('mb-dates-input');
  var formatHidden = document.getElementById('mb-format-input');
  if (!memoryMode || !occWrap || !listWrap) return;

  // (The ad's dateLabel is NOT written onto the pill — it can be a date value,
  // which would look pre-filled. The pill stays "Your date" until the customer picks one.)

  var ICON = {
    heart:'<path d="M12 21s-7-4.6-9.3-8.6C1.2 9.7 2.6 6.5 5.6 6.2 7.6 6 9 7.2 12 10c3-2.8 4.4-4 6.4-3.8 3 .3 4.4 3.5 2.9 6.2C19 16.4 12 21 12 21z"/>',
    ring:'<circle cx="12" cy="15" r="5"/><path d="M9 9l3-4 3 4"/>',
    balloon:'<path d="M12 3c3.3 0 5 2.6 5 6s-2.2 6-5 6-5-2.6-5-6 1.7-6 5-6z"/><path d="M12 15v3m0 0c-1 0-1.4 1-1 2m1-2c1 0 1.4 1 1 2"/>',
    rings:'<circle cx="9.5" cy="13" r="5"/><circle cx="15.5" cy="13" r="5"/>',
    feet:'<path d="M8 6c1.2 0 2 1.4 2 3.2S9.2 13 8 13s-2-1.4-2-3.8S6.8 6 8 6z"/><path d="M6 15.5c0-1.4 1-2.2 2-2.2s2 .8 2 2.2c0 1.6-.8 2.5-2 2.5s-2-.9-2-2.5z"/><path d="M16 7c1.2 0 2 1.4 2 3.2S17.2 14 16 14s-2-1.4-2-3.8S14.8 7 16 7z"/><path d="M14 16.5c0-1.4 1-2.2 2-2.2s2 .8 2 2.2c0 1.6-.8 2.5-2 2.5s-2-.9-2-2.5z"/>',
    house:'<path d="M4 11l8-6 8 6"/><path d="M6 10v9h12v-9"/><path d="M10 19v-5h4v5"/>',
    suitcase:'<rect x="4" y="8" width="16" height="11" rx="2"/><path d="M9 8V6h6v2"/><path d="M12 11v5"/>',
    cake:'<path d="M5 21h14v-7H5z"/><path d="M5 14c1.5 1.2 3 1.2 4.7 0 1.5 1.2 3 1.2 4.6 0 1.6 1.2 3.1 1.2 4.7 0"/><path d="M12 7v3M9 7v3M15 7v3"/><path d="M12 3v2M9 4v1M15 4v1"/>',
    cap:'<path d="M3 9l9-4 9 4-9 4-9-4z"/><path d="M7 11v4c0 1.4 2.2 2.5 5 2.5s5-1.1 5-2.5v-4"/>',
    plane:'<path d="M10 4l9 8-9 8-1.5-1.5 4-6.5H4l-1-2 1-2h8.5l-4-6.5z"/>',
    gift:'<rect x="4" y="9" width="16" height="11" rx="1"/><path d="M4 13h16M12 9v11"/><path d="M12 9C10.5 6 7 6 7 8.4 7 9 9.5 9 12 9zm0 0c1.5-3 5-3 5-.6C17 9 14.5 9 12 9z"/>',
    bulb:'<path d="M9 18h6M10 21h4"/><path d="M12 3a6 6 0 0 1 4 10.5c-.6.6-1 1.3-1 2.1V16H9v-.4c0-.8-.4-1.5-1-2.1A6 6 0 0 1 12 3z"/>',
    baby:'<circle cx="12" cy="12" r="8.5"/><path d="M12 3.5c.5-1.2 2-1.2 2.4 0"/><path d="M9.5 11.5h.01M14.5 11.5h.01"/><path d="M9.5 14.5c1.4 1.2 3.6 1.2 5 0"/>'
  };
  function svg(n) { return ICON[n] || ICON.heart; }

  function today() {
    var d = new Date(), p = function (n) { return ('0' + n).slice(-2); };
    return p(d.getDate()) + '.' + p(d.getMonth() + 1) + '.' + String(d.getFullYear()).slice(-2);
  }
  function esc(s) { return String(s).replace(/"/g, '&quot;').replace(/</g, '&lt;'); }
  function pad2(n) { return ('0' + n).slice(-2); }

  // ───── Date value helpers (stored as DD.MM.YY — what the print loop reads) ──
  // Year range round-trips cleanly through the 2-digit store (pivot at 30:
  // 00–30 => 2000s, 31–99 => 1900s) → 1931–2030.
  var MONTHS_SHORT = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var YEAR_MIN = 1931, YEAR_MAX = 2030;

  function parseDMY(s) {
    var m = /^(\d{2})\.(\d{2})\.(\d{2})$/.exec((s || '').trim());
    if (!m) return null;
    var yy = parseInt(m[3], 10);
    return { d: parseInt(m[1], 10), m: parseInt(m[2], 10), y: (yy <= 30 ? 2000 + yy : 1900 + yy) };
  }
  function composeDMY(d, m, y) {
    if (!d || !m || !y) return '';
    return pad2(d) + '.' + pad2(m) + '.' + String(y).slice(-2);
  }
  // Mask free typing into DD.MM.YY: auto-insert the dots and clamp the day (1–31) and
  // month (1–12) once each pair is complete. Returns the masked (possibly partial) string.
  function maskDMY(raw) {
    var s = String(raw || '').replace(/\D/g, '').slice(0, 6);
    var dd = s.slice(0, 2), mm = s.slice(2, 4), yy = s.slice(4, 6);
    if (dd.length === 2) { var dn = parseInt(dd, 10); dd = pad2(dn > 31 ? 31 : (dn < 1 ? 1 : dn)); }
    if (mm.length === 2) { var mn = parseInt(mm, 10); mm = pad2(mn > 12 ? 12 : (mn < 1 ? 1 : mn)); }
    var out = dd;
    if (mm.length) out += '.' + mm;
    if (yy.length) out += '.' + yy;
    return out;
  }
  function isFullDMY(s) { return /^\d{2}\.\d{2}\.\d{2}$/.test(s || ''); }
  function dayOptions(sel) {
    var out = '<option value="">Day</option>', d;
    for (d = 1; d <= 31; d++) out += '<option value="' + d + '"' + (sel === d ? ' selected' : '') + '>' + d + '</option>';
    return out;
  }
  function monthOptions(sel) {
    var out = '<option value="">Month</option>', m;
    for (m = 1; m <= 12; m++) out += '<option value="' + m + '"' + (sel === m ? ' selected' : '') + '>' + MONTHS_SHORT[m - 1] + '</option>';
    return out;
  }
  function yearOptions(sel) {
    var out = '<option value="">Year</option>', y;
    for (y = YEAR_MAX; y >= YEAR_MIN; y--) out += '<option value="' + y + '"' + (sel === y ? ' selected' : '') + '>' + y + '</option>';
    return out;
  }

  // ───── Date picker popover (day / month / year dropdowns) ─────
  var pop = null, popDD, popMM, popYY, popOnChange = null;
  function ensurePop() {
    if (pop) return pop;
    pop = document.createElement('div');
    pop.className = 'mb-dpick'; pop.hidden = true;
    pop.innerHTML =
      '<div class="mb-dpick-row">' +
        '<select class="mb-dpick-sel mb-dpick-dd" aria-label="Day"></select>' +
        '<select class="mb-dpick-sel mb-dpick-mm" aria-label="Month"></select>' +
        '<select class="mb-dpick-sel mb-dpick-yy" aria-label="Year"></select>' +
      '</div>';
    document.body.appendChild(pop);
    popDD = pop.querySelector('.mb-dpick-dd');
    popMM = pop.querySelector('.mb-dpick-mm');
    popYY = pop.querySelector('.mb-dpick-yy');
    pop.addEventListener('click', function (e) { e.stopPropagation(); });
    function onSel() {
      var d  = parseInt(popDD.value, 10) || 0;
      var mo = parseInt(popMM.value, 10) || 0;
      var y  = parseInt(popYY.value, 10) || 0;
      if (popOnChange) popOnChange(composeDMY(d, mo, y));
      if (d && mo && y) closePop();   // day + month + year all set → auto-close
    }
    popDD.addEventListener('change', onSel);
    popMM.addEventListener('change', onSel);
    popYY.addEventListener('change', onSel);
    document.addEventListener('click', closePop);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePop(); });
    window.addEventListener('resize', closePop);
    return pop;
  }
  function openPop(anchor, dmyStr, onChange) {
    ensurePop();
    var p = parseDMY(dmyStr) || { d: 0, m: 0, y: 0 };
    popDD.innerHTML = dayOptions(p.d);
    popMM.innerHTML = monthOptions(p.m);
    popYY.innerHTML = yearOptions(p.y);
    popOnChange = onChange;
    pop.hidden = false;
    var rect = anchor.getBoundingClientRect();
    var vw = document.documentElement.clientWidth;
    var width = pop.offsetWidth || 220;
    var left = rect.left + window.scrollX;
    if (left + width > window.scrollX + vw - 8) left = window.scrollX + vw - width - 8;
    if (left < window.scrollX + 8) left = window.scrollX + 8;
    pop.style.top = (rect.bottom + window.scrollY + 6) + 'px';
    pop.style.left = left + 'px';
  }
  function closePop() { if (pop) { pop.hidden = true; popOnChange = null; } }

  // ───── Inspiration themes (each adds dated "moments") ─────
  var THEMES = [
    { name: 'Your partner', icon: 'heart', moments: [
        { date:'07.04.19', label:'The Day We Met',         icon:'heart' },
        { date:'12.08.20', label:'First Holiday Together', icon:'plane' },
        { date:'11.11.21', label:'Moved In Together',      icon:'house' },
        { date:'18.06.22', label:'The Proposal',           icon:'ring'  },
        { date:'16.09.23', label:'Wedding Day',            icon:'rings' },
        { date:'04.02.26', label:'Our First Baby',         icon:'feet'  } ] },
    { name: 'New Baby', icon: 'baby', moments: [
        { date:'04.02.26', label:'The Day You Arrived', icon:'feet'    },
        { date:'04.02.26', label:'First Cuddle',        icon:'heart'   },
        { date:'20.02.26', label:'First Smile',         icon:'balloon' },
        { date:'01.06.26', label:'First Steps',         icon:'feet'    },
        { date:'04.09.26', label:'First Word',          icon:'heart'   },
        { date:'04.02.27', label:'First Birthday',      icon:'cake'    } ] },
    { name: 'Birthday', icon: 'cake', moments: [
        { date:'02.05.90', label:'The Big Day',    icon:'cake'    },
        { date:'02.05.95', label:'Sweet Sixteen',  icon:'balloon' },
        { date:'02.05.10', label:'Turning Twenty', icon:'cake'    },
        { date:'02.05.20', label:'The Big One',    icon:'balloon' },
        { date:'02.05.25', label:'The Party',      icon:'cake'    },
        { date:'02.05.30', label:'Another Year',   icon:'balloon' } ] },
    { name: 'New Home', icon: 'house', moments: [
        { date:'11.11.21', label:'Got The Keys',    icon:'house'    },
        { date:'20.11.21', label:'First Night In',  icon:'heart'    },
        { date:'05.12.21', label:'Moving Day',      icon:'suitcase' },
        { date:'24.12.21', label:'First Christmas', icon:'gift'     },
        { date:'01.06.22', label:'Garden Done',     icon:'house'    },
        { date:'11.11.22', label:'One Year Here',   icon:'cake'     } ] },
    { name: 'Thank You', icon: 'gift', moments: [
        { date:'09.07.24', label:'The Day You Helped', icon:'gift'    },
        { date:'09.07.24', label:'Always There',       icon:'heart'   },
        { date:'09.07.24', label:'Going Above',        icon:'balloon' },
        { date:'09.07.24', label:'A True Friend',      icon:'heart'   },
        { date:'09.07.24', label:'Forever Grateful',   icon:'gift'    },
        { date:'09.07.24', label:'Simply The Best',    icon:'rings'   } ] }
  ];

  var state = { list: [], active: 0, theme: -1 };
  var memoryActive = false;
  var sixTicked = false; // "Make it six dates" toggle
    var sameDate = false, sharedDate = '';
  var sameDateRow   = document.getElementById('mb-dates-samedate-row');
  var sameDateCb    = document.getElementById('mb-dates-samedate-checkbox');
  var sharedDateBlk = document.getElementById('mb-dates-shareddate-block');
  var sharedDateBtn = document.getElementById('mb-dates-shareddate');
    var datesUnique = false; // box-of-12 only: false = 6 dates (repeated), true = 12 unique
  var splitRow   = document.getElementById('mb-dates-split');
  var split6cb   = document.getElementById('mb-dates-split-6-cb');
  var split12cb  = document.getElementById('mb-dates-split-12-cb');
  var split6row  = document.getElementById('mb-dates-split-6');
  var split12row = document.getElementById('mb-dates-split-12');

  function boxSize() {
    var sel = document.querySelector('.bb-size-card.selected');
    return sel ? parseInt(sel.dataset.size, 10) : 6;
  }

    function slotCount() {
    var bars = boxSize();
    if (bars === 12) return datesUnique ? 12 : 6;
    return bars; // box of 6 → 6
  }
  function updateSplitVisibility() {
    var show = (boxSize() === 12 && sixTicked);
    if (splitRow) splitRow.hidden = !show;
    if (split6cb)  split6cb.classList.toggle('checked', !datesUnique);
    if (split12cb) split12cb.classList.toggle('checked', datesUnique);
  }
  function resizeDates() {
    var target = slotCount();
    while (state.list.length < target) state.list.push({ date: '', label: '', isNew: true });
    if (state.list.length > target) state.list.length = target;
    if (state.active >= target) state.active = target - 1;
    if (state.active < 0) state.active = 0;
  }
  function setDatesUnique(on) {
    datesUnique = !!on;
    resizeDates();
    updateSplitVisibility();
    render();
  }

  function divisorList(n) {
    var ds = [], i;
    for (i = 1; i <= n; i++) if (n % i === 0) ds.push(i);
    if (ds.length <= 1) return String(ds[0] || n);
    return ds.slice(0, -1).join(', ') + ' or ' + ds[ds.length - 1];
  }

  // ───── Inspiration / suggestion tiles ─────
  function renderTiles() {
    occWrap.innerHTML = '';
    // Only drill into a theme's sub-moments once "personalise all bars" is ticked.
    var drill = sixTicked && state.theme >= 0;
    if (ideasHead) ideasHead.textContent = drill ? 'Suggested moments' : 'Need inspiration?';
    if (writeOwn) writeOwn.hidden = !drill;

    if (!drill) {
      occWrap.classList.add('is-grid');
      // Themed-ad override: show the ad theme's date occasions; a tap adds that moment.
      var adDates = (window.bbAdTheme && window.bbAdTheme.date && window.bbAdTheme.date.length) ? window.bbAdTheme.date : null;
      if (adDates) {
        adDates.forEach(function (m) {
          var el = document.createElement('div');
          el.className = 'mb-occ';
          el.innerHTML = '<svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round">' + svg(m.icon) + '</svg><div class="mb-occ-label">' + esc(m.occasion || '') + '</div>';
          el.addEventListener('click', function () { addMoment(m.occasion); });
          occWrap.appendChild(el);
        });
        return;
      }
      THEMES.forEach(function (t, i) {
        var el = document.createElement('div');
        el.className = 'mb-occ';
        el.innerHTML = '<svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round">' + svg(t.icon) + '</svg><div class="mb-occ-label">' + t.name + '</div>';
        el.addEventListener('click', function () { chooseTheme(i); });
        occWrap.appendChild(el);
      });
      return;
    }

    var used = {};
    occWrap.classList.add('is-grid');
    state.list.forEach(function (r) { used[(r.label || '').toLowerCase()] = true; });
    var any = false;
    THEMES[state.theme].moments.forEach(function (m) {
      if (used[m.label.toLowerCase()]) return;
      any = true;
      var el = document.createElement('div');
      el.className = 'mb-occ';
      el.innerHTML = '<svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round">' + svg(m.icon) + '</svg><div class="mb-occ-label">' + m.label + '</div>';
      el.addEventListener('click', function () { addMoment(m.label); });
      occWrap.appendChild(el);
    });
    if (!any) { state.theme = -1; renderTiles(); } // theme exhausted → offer themes again
  }

  // ───── Adding moments ─────
  function trailingEmptyRow() {
    var last = state.list[state.list.length - 1];
    if (last && !(last.date || '').trim() && !(last.label || '').trim()) return last;
    return null;
  }
  function addEmptyMoment() {
    if (!ensureCanAddMore()) return;
    if (state.list.length >= boxSize()) return;
    var last = state.list[state.list.length - 1];
    if (last && (!(last.date || '').trim() || !(last.label || '').trim())) {
      // last moment isn't finished — focus it instead of adding another
      var ex = listWrap.querySelector('.mb-drow:last-child .mb-drow-label');
      if (ex) ex.focus();
      return;
    }
    state.list.push({ date: '', label: '', isNew: true });
    state.active = state.list.length - 1;
    render();
    var d = listWrap.querySelector('.mb-drow:last-child .mb-drow-label');
    if (d) d.focus();
  }

  function firstOpenSlotIndex() {
    for (var i = 0; i < state.list.length; i++) {
      if (!((state.list[i].label || '').trim())) return i;
    }
    return -1;
  }
  // How many moments actually have content.
  function filledMomentCount() {
    return state.list.filter(function (r) { return (r.label || '').trim(); }).length;
  }
  // Flash the "Personalise all six bars (+£2)" tick to draw the eye to it.
  function flashSixRow() {
    try {
      if (sixRow) sixRow.animate([
        { boxShadow: '0 0 0 0 rgba(243,210,106,0)' },
        { boxShadow: '0 0 0 3px rgba(243,210,106,0.95)' },
        { boxShadow: '0 0 0 0 rgba(243,210,106,0)' }
      ], { duration: 750 });
      if (sixCheckbox) sixCheckbox.animate([
        { transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }
      ], { duration: 450 });
    } catch (e) {}
  }
  // A second moment onwards requires the "+£2" six-bars tick. Without it, block
  // the add and flash the tick box instead.
  function ensureCanAddMore() {
    if (sixTicked || filledMomentCount() < 1) return true; // first moment always allowed
    flashSixRow();
    return false;
  }
  function addMoment(label) {
    if (!ensureCanAddMore()) return;
    var idx = firstOpenSlotIndex();
    if (idx === -1) {
      if (state.list.length >= boxSize()) return; // no open slot and box is full
      state.list.push({ date: '', label: label, isNew: true });
      idx = state.list.length - 1;
    } else {
      state.list[idx].label = label;
      state.list[idx].isNew = true;
    }
    state.active = idx;
    render();
    if (!sameDate) openDateForRow(idx); // skip the per-row picker when one date is shared
  }
  // Focus a row's date field (used after a suggestion is added) so the customer can type it.
  function openDateForRow(idx) {
    setTimeout(function () {
      var rowEl = listWrap.children[idx];
      if (!rowEl) return;
      var dateInput = rowEl.querySelector('.mb-drow-date');
      if (!dateInput) return;
      setActive(idx);
      dateInput.focus();
    }, 0);
  }
  function chooseTheme(i) {
    state.theme = i;
    if (!sixTicked) {
      // Single-moment mode: set/replace the one moment's occasion with this theme's
      // first idea. Keep any date already chosen; otherwise open the date picker.
      var first = THEMES[i].moments[0];
      var existingDate = state.list[0] ? state.list[0].date : '';
      state.list = [{ date: existingDate, label: first.label, isNew: true }];
      state.active = 0;
      render();
      if (!existingDate) openDateForRow(0);
      return;
    }
    addMoment(THEMES[i].moments[0].label);
  }
  function removeRow(idx) {
    state.list.splice(idx, 1);
    if (state.list.length === 0) { state.theme = -1; sixTicked = false; } // emptied → back to initial state
    if (state.active >= state.list.length) state.active = state.list.length - 1;
    if (state.active < 0) state.active = 0;
    render();
  }

  function setActive(i) {
    state.active = i;
    [].forEach.call(listWrap.children, function (c, n) { c.classList.toggle('is-active', n === i); });
    paint();
  }

  function render() {
    // Keep the bars in sync only while "same date" is on AND they haven't
    // diverged — never re-collapse dates the customer has since made different.
    if (sameDate && sixTicked && distinctDateCount() <= 1) applySharedDate();
    listWrap.innerHTML = '';
    // Box of 12 = 6 unique messages across 12 bars (2 bars each), so labels pair up:
    // "1st and 2nd bar", "3rd and 4th bar"… Box of 6 stays "1st bar", "2nd bar"…
    var _ord = function (n) { var s = ['th', 'st', 'nd', 'rd'], v = n % 100; return n + (s[(v - 20) % 10] || s[v] || s[0]); };
    var _pairBars = (boxSize() === 12);
    state.list.forEach(function (row, idx) {
      var r = document.createElement('div');
      r.className = 'mb-drow' + (idx === state.active ? ' is-active' : '');
      var _barLbl = _pairBars ? (_ord(idx * 2 + 1) + ' and ' + _ord(idx * 2 + 2) + ' bar') : (_ord(idx + 1) + ' bar');
      r.innerHTML =
        '<div class="mb-drow-barlabel" aria-hidden="true">' + _barLbl + '</div>' +
        '<input type="text" class="mb-drow-name" maxlength="10" value="' + esc(row.name || '') + '" placeholder="Name" aria-label="Name">' +
        '<input type="text" inputmode="numeric" class="mb-drow-date' + (row.date ? '' : ' is-empty') + '" maxlength="8" placeholder="dd.mm.yy" aria-label="Date, day month year" value="' + esc(row.date) + '">' +
        '<input class="mb-drow-label" maxlength="25" value="' + esc(row.label) + '" placeholder="Your message" aria-label="Your message">';

      var dateBtn  = r.querySelector('.mb-drow-date');
      var li       = r.querySelector('.mb-drow-label');
      var nameIn   = r.querySelector('.mb-drow-name');

      r.addEventListener('click', function () { setActive(idx); });

      if (nameIn) nameIn.addEventListener('input', function () {
        setActive(idx); row.name = nameIn.value; paint(); writeProps(); updateUI();
      });

      dateBtn.addEventListener('input', function () {
        // Always edit just this bar's date. If that leaves the bars holding more than one
        // date, updateSameDateUI() unticks + hides the "same date on each bar" option —
        // the dates themselves stay put.
        setActive(idx);
        var v = maskDMY(dateBtn.value);
        dateBtn.value = v;
        dateBtn.classList.toggle('is-empty', !v);
        row.date = v;
        paint(); writeProps(); updateUI();
      });

      li.addEventListener('input', function () {
        row.label = li.value; row.isNew = false;
        var b = r.querySelector('.mb-drow-badge'); if (b) b.remove();
        paint(); writeProps(); updateUI();
      });

      listWrap.appendChild(r);
    });

    updateUI();
    renderTiles();
    paint();
    writeProps();
    // Wire the char counter onto the freshly-rendered per-bar message inputs (idempotent).
    if (window.bbWireCounters) window.bbWireCounters();
  }

  // ───── Bar map: which moment shows on each of the box's bars ─────
  // Divides the box's bars across the moments. For divisor counts the split is
  // exact (box of 6: 1→all six, 2→3+3, 3→2+2+2, 6→one each). For counts that
  // don't divide evenly (e.g. 4 or 5 on a box of 6) the remainder is front-
  // loaded onto the earliest moments — PLACEHOLDER until the 4-moment rule is
  // decided. Returns an array of length `bars` holding the moment index per bar.
  function barAssignment(n, bars) {
    var out = [];
    if (n <= 0) return out;
    if (n >= bars) { for (var k = 0; k < bars; k++) out.push(k); return out; } // 1 moment per bar, extras ignored
    var base = Math.floor(bars / n);
    var rem  = bars % n;
    for (var i = 0; i < n; i++) {
      var count = base + (i < rem ? 1 : 0); // front-load the remainder
      for (var j = 0; j < count; j++) out.push(i);
    }
    return out;
  }

  function renderBarMap() {
    if (!barMap) return;
    var n = state.list.length, bars = boxSize();
    if (n < 1) { barMap.hidden = true; barMap.innerHTML = ''; return; }
    barMap.hidden = false;
    var assign = barAssignment(n, bars);
    var html = '';
    for (var b = 0; b < bars; b++) {
      var row = state.list[assign[b]] || {};
      var txt = (row.label || '').trim() || (row.date || '').trim();
      html += '<div class="mb-bar"><span class="mb-bar-text">' + esc(txt) + '</span></div>';
    }
    barMap.innerHTML = html;
  }

  function updateUI() {
    var n = state.list.length, bars = boxSize();
    // hide the "Some ideas" suggestions only once a date has actually been entered
    var hasDate = state.list.some(function (r) { return (r.date || '').trim(); });
    if (panel) panel.classList.toggle('mb-has-moments', hasDate);
    var last = state.list[n - 1];
    var lastComplete = !last || ((last.date || '').trim() && (last.label || '').trim());
    if (firstEntry) firstEntry.hidden = (n !== 0); // two-box entry only in the empty state
    // six-dates tick is visible from the start (before any input is filled), below the inputs
    var firstComplete = (n >= 1) && (state.list[0].date || '').trim() && (state.list[0].label || '').trim();
        if (sixRow) sixRow.hidden = false;
    updateSplitVisibility();
    if (sixWord) sixWord.textContent = (bars === 12) ? 'twelve' : 'six';
    if (sixCheckbox) sixCheckbox.classList.toggle('checked', sixTicked);
        updateSameDateUI();
    // Gifting shows this from the start (before the inputs are filled); self-buy waits until complete.
    if (datesFoot) datesFoot.hidden = sixTicked;   // show from the start on every page + both box sizes (6/12); only hidden once six-loops is ticked
    if (datesFootNum) datesFootNum.textContent = bars;
    if (addBtn) {
      var atMax = (n >= bars);
      addBtn.textContent = '+ Add another moment';
      // can't add another until the current moment has both a date and a memory
      addBtn.disabled = atMax || (n > 0 && !lastComplete);
      // hidden in the empty state (the two boxes start the first moment) and once full
            addBtn.style.display = (n === 0 || atMax || !sixTicked) ? 'none' : '';
    }
    if (tipBox) tipBox.hidden = false; // always show the "Start with one date" tip (mirrors the name tip)
    if (footText) {
      footText.textContent = 'You can have ' + divisorList(bars) + ' moments. Each moment appears across the ' + bars + ' bars in your box.';
    }
    if (infoBox) {
      infoBox.hidden = n === 0;
      if (n > 0) {
        if (infoTitle) infoTitle.textContent = 'Your story currently has ' + n + (n === 1 ? ' moment.' : ' moments.');
        if (infoSub) {
          if (n === 1) infoSub.textContent = 'This moment will appear on all ' + bars + ' bars in your box.';
          else if (n === bars) infoSub.textContent = 'A different moment on each of your ' + bars + ' bars.';
          else infoSub.textContent = 'Your ' + n + ' moments are shared across your ' + bars + ' bars.';
        }
      }
    }
    renderBarMap();
  }
  function applySharedDate() {
    for (var i = 0; i < state.list.length; i++) state.list[i].date = sharedDate;
  }
  // How many distinct (non-empty) dates the bars currently hold.
  function distinctDateCount() {
    var seen = {};
    for (var i = 0; i < state.list.length; i++) {
      var d = (state.list[i].date || '').trim();
      if (d) seen[d] = 1;
    }
    return Object.keys(seen).length;
  }
  function updateSameDateUI() {
    var distinct = distinctDateCount();
    // Once the bars hold more than one distinct date the "same date" link is
    // broken — untick it, but leave every date exactly as the customer set it.
    if (distinct > 1 && sameDate) sameDate = false;
    // Offer "Same date on each bar" only after a first date is entered, and only
    // while the bars still share that single date (nothing has diverged yet).
    var showSame = sixTicked && distinct === 1;
    if (sameDateRow) sameDateRow.hidden = !showSame;
    if (sameDateCb) sameDateCb.classList.toggle('checked', sameDate);
    // Each row keeps its own date next to the message; the separate shared-date
    // field at the bottom stays hidden.
    if (sharedDateBlk) sharedDateBlk.hidden = true;
    if (listWrap) listWrap.classList.remove('mb-samedate-on');
  }

  function paint() {
    if (overlayTop) overlayTop.classList.remove('is-dotev'); // keep RW italic style, not the Names face
    var row = state.list[state.active] || state.list[0] || { date: '', label: '' };
    if (overlayTop) overlayTop.textContent = (row.date || '').trim() || '21.09.26';
    if (overlayBot) overlayBot.textContent = (row.label || '').trim() || 'Our first date';
  }

  function setSix(on) {
    window.bbStoryState = window.bbStoryState || {};
    if (window.bbStoryState.sixDates !== on) {
      window.bbStoryState.sixDates = on;
      if (window.bbRefreshForStory) window.bbRefreshForStory();
    }
  }

  // Gate the Remember-when +£2 on actually having a moment with content, so an
  // open-but-empty Dates panel is priced as a plain box until you add something.
  function applyStoryPricing(hasContent) {
    window.bbStoryState = window.bbStoryState || {};
    // Price the Date personalisation whenever the "A Date" card is selected (clicked
    // or interacted with) OR there's content — selecting the option opts in.
    var on = hasContent || !!document.querySelector('.bb-opt2-card[data-opt2="date"].is-selected');
    // Name-on-top SIX-unique is really a per-bar NAMES personalisation, so route + price it as Names
    // (NAMES_PER_BAR — the SAME £28.99/£42.99 as message six-unique) rather than Remember-when. This drives
    // _Add your story = 'Names' so print-names-order renders each bar's own name in the name font. It does
    // NOT switch the visible UI mode (setMode is only called from an explicit card click). Everything else
    // (single message, date-on-top, keep-logo) stays Remember-when.
    var _mmSN = document.getElementById('mb-memory-mode');
    var _showName = !!(_mmSN && _mmSN.classList.contains('show-name'));
    var want = on ? (_showName ? 'Names' : 'Remember when') : null;
    // Per-bar NAMES_PER_BAR pricing (£28.99/£42.99) is only for six-unique; a SINGLE name-on-top is a
    // one-off Names personalisation (STORY_PRODUCTS['Names'] = £24.99, same +£5 as a single message).
    window.bbStoryState.namesPerBar = (_showName && sixTicked);
    if (window.bbStoryState.story !== want) {
      window.bbStoryState.story = want;
    }
    // Always reprice (see applyNamesPricing) — content arriving AFTER the card click must update the CTA.
    if (window.bbRefreshForStory) window.bbRefreshForStory();
    if (hasContent && window.bbSelectOpt2Card) window.bbSelectOpt2Card(_showName ? 'name' : 'date');
    if (window.bbUpdateButtons) window.bbUpdateButtons();  // re-validate express/add on content change
  }

  // Write the SAME properties the print loop already reads.
  function writeProps() {
    if (!memoryActive) {
      if (topHidden) topHidden.value = '';
      if (bottomHidden) bottomHidden.value = '';
      if (datesHidden) datesHidden.value = '';
      if (formatHidden) formatHidden.value = '';
      setSix(false);
      return;
    }
    var filled = state.list.filter(function (r) { return (r.date || '').trim() || (r.label || '').trim(); });
    var sixMode = sixTicked || filled.length >= 2;
    applyStoryPricing(filled.length > 0 || sixTicked);
    if (filled.length === 0 && !sixTicked) {
      if (topHidden) topHidden.value = '';
      if (bottomHidden) bottomHidden.value = '';
      if (datesHidden) datesHidden.value = '';
      if (formatHidden) formatHidden.value = '';
      setSix(false);
      return;
    }
    if (!sixMode) {
      var r = filled[0] || state.list[0] || { date: '', label: '' };
      var _mmS = document.getElementById('mb-memory-mode');
      var _nameSH = document.getElementById('mb-name-input');
      var _anecSH = document.getElementById('mb-anecdote-input');
      if (_mmS && _mmS.classList.contains('show-name')) {
        // SINGLE name-on-top → a NAMES personalisation: the single-name field is the name, the message is the
        // anecdote. This drives _Add your story = 'Names', so the cart shows a Name box (not a Date) and
        // print-names-order renders the name in the name font. Clear the date/message props so the SAME line
        // isn't ALSO read as a Remember-when date.
        // The single name lives in one of two fields depending on the view (message-first #mb-first-name or
        // the Names-persona #mb-name-line); the message can be the committed row OR #mb-anecdote-line. Read
        // from whichever actually holds a value, and NEVER clobber a captured name/message back to empty —
        // several controllers write these hidden inputs and a bare overwrite here would race them to blank.
        var _fn = document.getElementById('mb-first-name');
        var _nl = document.getElementById('mb-name-line');
        var _al = document.getElementById('mb-anecdote-line');
        var _nameVal = ((_fn && _fn.value) || (_nl && _nl.value) || (_nameSH && _nameSH.value) || '').trim();
        var _anecVal = ((r.label || '').trim() || (_al && _al.value) || (_anecSH && _anecSH.value) || '').trim();
        if (_nameSH && _nameVal) _nameSH.value = window.bbCpSlice(_nameVal, 10);
        if (_anecSH) _anecSH.value = _anecVal ? window.bbCpSlice(_anecVal, 20) : (_nameVal ? 'no message' : _anecSH.value);
        if (topHidden) topHidden.value = '';
        if (bottomHidden) bottomHidden.value = '';
        if (datesHidden) datesHidden.value = '';
        if (formatHidden) formatHidden.value = '';
      } else {
        // Date-on-top OR keep-logo → date + message. Keep-logo simply leaves _Top Line empty (message only);
        // the cart hides the empty date box. Clear the name props so a switched-away name doesn't linger and
        // get the order mis-read as Names.
        if (topHidden) topHidden.value = (r.date || '').trim();
        var _bl2 = window.bbCpSlice((r.label || '').trim(), 25);
        if (bottomHidden) bottomHidden.value = _bl2 || (((r.date || '').trim()) ? 'no message' : '');
        if (datesHidden) datesHidden.value = '';
        if (_nameSH) _nameSH.value = '';
        if (_anecSH) _anecSH.value = '';
        if (formatHidden) formatHidden.value = 'Date + Memory';
      }
      setSix(false);
    } else {
      // Six unique: serialise EVERY bar position (state.list holds one entry per bar in six-mode), NOT
      // just the filled ones. Otherwise the print pairs dates[i % filledCount] → bar i and cycles bar 1's
      // text across every empty bar (the "spread" bug). With all positions present, dates.length === box
      // size, so the print lands each bar's own message 1:1. Empty date → "—" (the parser maps that back
      // to '' but keeps the position, since "—" is truthy); empty message → "".
      // Only serialise once at least one bar has content — otherwise a six box with nothing typed would
      // write six empty "— – " slots, which the print parser (dates.length > 0) would misread as real
      // content and print blank bars. No content → empty _Dates → parser flags it storyEmpty (skipped).
      var _mmW = document.getElementById('mb-memory-mode');
      var _sixNameW = !!(_mmW && _mmW.classList.contains('show-name'));
      var namesHidden = document.getElementById('mb-names-input');
      var nameSingleH = document.getElementById('mb-name-input');
      var anecSingleH = document.getElementById('mb-anecdote-input');
      if (_sixNameW) {
        // Name-on-top → per-bar NAME + message goes to _Names ("name – msg | ...", "—" for a blank name),
        // one entry per bar so print-names-order renders each bar's own name (name font). Same all-positions
        // rule as _Dates so empty bars stay empty (no cycling). Content check includes the name.
        var _anyNameW = state.list.some(function (r) { return (r.name || '').trim() || (r.label || '').trim(); });
        var nparts = _anyNameW ? state.list.map(function (r) {
          var _nm = (r.name || '').trim(), _mg = window.bbCpSlice((r.label || '').trim(), 25);
          // Bars WITH a name but no message carry an explicit 'no message' (intentional — prints name
          // only; the backend strips the marker before render). Untouched bars stay blank.
          return (_nm || '—') + ' – ' + (_mg || (_nm ? 'no message' : ''));
        }) : [];
        if (namesHidden) namesHidden.value = window.bbCpSlice(nparts.join(' | '), 255);
        if (nameSingleH) nameSingleH.value = '';   // per-bar → clear single-name props so the parser uses _Names
        if (anecSingleH) anecSingleH.value = '';
        if (datesHidden) datesHidden.value = '';
        if (topHidden) topHidden.value = '';
        if (bottomHidden) bottomHidden.value = '';
        if (formatHidden) formatHidden.value = '';
        // story = 'Names' + namesPerBar already set by applyStoryPricing above (routes print + prices £28.99).
      } else {
        var parts = filled.length ? state.list.map(function (r) {
          var _dt = (r.date || '').trim(), _mg2 = window.bbCpSlice((r.label || '').trim(), 25);
          return (_dt || '—') + ' – ' + (_mg2 || (_dt ? 'no message' : ''));
        }) : [];
        if (datesHidden) datesHidden.value = window.bbCpSlice(parts.join(' | '), 255);
        if (namesHidden) namesHidden.value = '';   // clear per-bar names when in date/message mode
        if (topHidden) topHidden.value = '';
        if (bottomHidden) bottomHidden.value = '';
        if (formatHidden) formatHidden.value = 'Six Dates';   // per-bar dates mode; box_size drives the bar count. The print parser only recognises 'Six Dates'.
        setSix(true);
      }
    }
  }
  // Let the "Above your message" (Date / Name / Keep logo) buttons re-serialise the order props when they
  // flip the top-type — otherwise switching Name→Date/Keep-logo would leave stale _Names/_Dates on the order.
  window.bbSyncPersoProps = writeProps;

  // Every date slot must have BOTH a date and an occasion (single: 1; six-dates: all slots).
  window.bbDatesComplete = function () {
    if (!memoryActive) return false;
    var filled = state.list.filter(function (r) { return (r.date || '').trim() || (r.label || '').trim(); });
    var sixMode = sixTicked || filled.length >= 2;
    // Message OPTIONAL (Barney 2026-08-07): a date alone is a legitimate purchase — the bar prints the
    // date and the order says "no message". Six: every slot needs its date. Single: the date.
    if (sixMode) {
      var dated = state.list.filter(function (r) { return (r.date || '').trim(); });
      return dated.length >= slotCount();
    }
    var r0 = filled[0];
    return !!(r0 && (r0.date || '').trim());
  };

  if (addBtn) addBtn.addEventListener('click', function () { addEmptyMoment(); });
  if (writeOwn) writeOwn.addEventListener('click', function (e) { e.preventDefault(); addEmptyMoment(); });

  // ───── "Make it six dates" tick — reveals the other 5 date fields ─────
  if (sixRow) sixRow.addEventListener('click', function () {
    sixTicked = !sixTicked;
    if (sixTicked) {
      resizeDates();
    } else {
      datesUnique = false;
      if (state.list.length > 1) { state.list = state.list.slice(0, 1); state.active = 0; }
    }
    updateSplitVisibility();
    render();
  });
  if (split6row)  split6row.addEventListener('click', function () { setDatesUnique(false); });
  if (split12row) split12row.addEventListener('click', function () { setDatesUnique(true); });

  // Public, idempotent "turn six on" — used by the message-first "Make every bar unique"
  // button. Pads state.list to the full slot count and re-renders so bars 2-6 appear, without
  // depending on a programmatic click bubbling through the hidden legacy #mb-dates-six-row.
  // The newly-added bars accordion (fold) open; row 1 (the message) stays put.
  function extraRows() {
    return listWrap ? [].slice.call(listWrap.querySelectorAll('.mb-drow')).slice(1) : [];
  }
  window.bbEnableSix = function () {
    sixTicked = true;
    resizeDates();
    updateSplitVisibility();
    render();
    // Fold the freshly-added bars (2-6) out from zero height.
    extraRows().forEach(function (r, i) {
      var h = r.offsetHeight;                 // natural height, measured before collapsing
      if (!h) return;                          // unmeasurable (hidden ancestor at this instant) — leave the row visible rather than risk collapsing it shut (box-12 six-unique safety net)
      r.style.overflow = 'hidden';
      r.style.maxHeight = '0px';
      r.style.opacity = '0';
      void r.offsetHeight;                    // apply the collapsed state
      r.style.transition = 'max-height 0.4s ease, opacity 0.4s ease';
      r.style.transitionDelay = (i * 0.05) + 's';
      r.style.maxHeight = h + 'px';
      r.style.opacity = '1';
      setTimeout(function () {                 // clear inline styles so focus outlines aren't clipped
        r.style.maxHeight = ''; r.style.overflow = ''; r.style.opacity = '';
        r.style.transition = ''; r.style.transitionDelay = '';
      }, 460 + i * 50);
    });
  };
  // Price as a single message RIGHT NOW, without touching the rows (no render/trim) — so the add-to-bag
  // price flips the instant "Same message on all six" is chosen, independent of the fold animation that
  // trims the extra rows at its end. Clears the six-unique surcharge (+£9 → +£5) and reprices immediately.
  window.bbPriceSingleMsg = function () {
    sixTicked = false;   // so any writeProps before the fold's bbTrimToSingle keeps single-message pricing
    setSix(false);       // bbStoryState.sixDates = false + bbRefreshForStory()
  };
  // Data-only trim back to a single moment (no animation) — used when the caller drives its own
  // fold+scroll animation and just needs the state/render updated once the rows have collapsed.
  window.bbTrimToSingle = function () {
    sixTicked = false;
    datesUnique = false;
    if (state.list.length > 1) { state.list = state.list.slice(0, 1); state.active = 0; }
    updateSplitVisibility();
    render();
  };
  window.bbDisableSix = function () {
    var rows = extraRows();
    var finish = function () {
      sixTicked = false;
      datesUnique = false;
      if (state.list.length > 1) { state.list = state.list.slice(0, 1); state.active = 0; }
      updateSplitVisibility();
      render();
    };
    if (!rows.length) { finish(); return; }
    // Fold the extra bars away, then trim + re-render once they've collapsed.
    rows.forEach(function (r) {
      r.style.maxHeight = r.offsetHeight + 'px';
      r.style.overflow = 'hidden';
      void r.offsetHeight;
      r.style.transition = 'max-height 0.35s cubic-bezier(0.33,1,0.68,1), opacity 0.35s cubic-bezier(0.33,1,0.68,1), margin 0.35s cubic-bezier(0.33,1,0.68,1), padding 0.35s cubic-bezier(0.33,1,0.68,1)';
      r.style.maxHeight = '0px';
      r.style.opacity = '0';
      r.style.marginBottom = '0px';
      r.style.marginTop = '0px';
      r.style.paddingTop = '0px';
      r.style.paddingBottom = '0px';
    });
    setTimeout(finish, 360);
  };

  // ───── "Same date on each bar" tick + shared date field ─────
  if (sameDateRow) sameDateRow.addEventListener('click', function () {
    sameDate = !sameDate;
    if (sameDate) {
      // Seed from the first date the customer actually entered, then copy it
      // onto every bar.
      var seed = '';
      for (var i = 0; i < state.list.length; i++) {
        var d = (state.list[i].date || '').trim();
        if (d) { seed = d; break; }
      }
      sharedDate = seed || sharedDate || '';
      applySharedDate();
    }
    render();
  });
  if (sharedDateBtn) sharedDateBtn.addEventListener('input', function () {
    var v = maskDMY(sharedDateBtn.value);
    sharedDateBtn.value = v;
    sharedDateBtn.classList.toggle('is-empty', !v);
    sharedDate = v;
    applySharedDate();
    paint(); writeProps(); updateUI();
  });



  // ───── Empty-state two-box entry (Date + Occasion) ─────
  // Either box creates moment 1, then editing continues in the normal row list.
  var pendingFirstDate = '';
  function commitFirstMoment() {
    if (state.list.length !== 0) return;            // only ever creates moment 1
    var dt = pendingFirstDate;
    var lb = firstOcc ? firstOcc.value : '';
    if (!dt && !(lb || '').trim()) return;          // nothing entered yet
    state.list.push({ date: dt, label: lb, isNew: true });
    state.active = 0;
    pendingFirstDate = '';
    if (firstOcc) firstOcc.value = '';
    if (firstDate) { firstDate.value = ''; firstDate.classList.add('is-empty'); }
    render();
    // carry on editing in the new row's occasion field
    var li = listWrap.querySelector('.mb-drow:last-child .mb-drow-label');
    if (li) { li.focus(); var v = li.value; li.value = ''; li.value = v; }
  }
  if (firstDate) firstDate.addEventListener('input', function () {
    var v = maskDMY(firstDate.value);
    firstDate.value = v;
    firstDate.classList.toggle('is-empty', !v);
    // Only treat the date as "entered" (and commit moment 1) once it's a full DD.MM.YY,
    // so a half-typed date doesn't prematurely create a row.
    pendingFirstDate = isFullDMY(v) ? v : '';
    if (pendingFirstDate) commitFirstMoment();
  });
  if (firstOcc) firstOcc.addEventListener('input', function () { commitFirstMoment(); });

  // Hard-cap the "What happened?" / occasion fields at 40 chars (belt-and-braces over the
  // maxlength attribute — catches paste / programmatic value setting on mobile & desktop).
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t) return;
    if (t.id === 'mb-first-occasion' || (t.classList && t.classList.contains('mb-drow-label'))) {
      if ((t.value || '').length > 25) { t.value = t.value.slice(0, 25); }
    }
  }, true);

  // ───── Dates / Chapters tabs (for now they only swap the title) ─────
  var TAB_TITLES = { dates: 'Every bar marks a moment', chapters: 'Chapters of a story' };
  var occTab = 'dates';
  function setTab(mode) {
    occTab = (mode === 'chapters') ? 'chapters' : 'dates';
    if (tabDates) tabDates.classList.toggle('is-active', occTab === 'dates');
    if (tabChapters) tabChapters.classList.toggle('is-active', occTab === 'chapters');
    if (occTitle) occTitle.textContent = TAB_TITLES[occTab];
  }
  if (tabDates) tabDates.addEventListener('click', function () { setTab('dates'); });
  if (tabChapters) tabChapters.addEventListener('click', function () { setTab('chapters'); });

  // Trim to the box size if it shrinks
  document.querySelectorAll('.bb-size-card').forEach(function (c) {
    c.addEventListener('click', function () {
      setTimeout(function () {
        if (!memoryActive) return;
        if (boxSize() === 6) datesUnique = false;
        if (sixTicked) resizeDates();
        var max = boxSize();
        if (state.list.length > max) { state.list = state.list.slice(0, max); if (state.active >= max) state.active = max - 1; }
        updateSplitVisibility();
        render();
      }, 0);
    });
  });

  // Called by the "ADD YOUR STORY (select + reveal panel)" block.
  window.bbMemorySync = function (active) {
    memoryActive = !!active;
    if (panel) panel.classList.toggle('is-occasion', memoryActive);
    if (memoryActive) {
      setTab(occTab); // applies the active tab's title (Dates / Chapters)
      if (occIcon) occIcon.innerHTML = svg('heart');
      render(); // empty state on first open
      // The "Need inspiration?" tiles can come up empty on first load (a
      // competing init — classic-fold reset / story sync — clears #mb-occasions
      // just after this first render, so they only appear after switching modes).
      // Re-populate the tiles across a few ticks, but ONLY when they're actually
      // missing, so we never blow away a half-typed date row.
      var ensureTiles = function () {
        if (memoryActive && occWrap && occWrap.children.length === 0) renderTiles();
      };
      requestAnimationFrame(ensureTiles);
      [80, 300, 800].forEach(function (d) { setTimeout(ensureTiles, d); });
      // the reveal block applies the story AFTER this runs, so re-assert
      // content-based pricing on the next tick (empty Dates stays unpriced)
      setTimeout(function () { if (memoryActive) writeProps(); }, 0);
    } else {
      writeProps();
    }
  };

  // start inactive
  window.bbMemorySync(false);

  // Prefill the Dates panel from the homepage AI builder (one {date,label} per bar).
  window.bbDatesPrefill = function (list) {
    list = list || [];
    sixTicked = list.length > 1;
    datesUnique = list.length > 6;        // box-of-12 unique-dates mode
    state.list = [];
    for (var i = 0; i < list.length; i++) {
      var e = list[i] || {};
      state.list.push({ date: (e.date || '').toString(), label: (e.label || '').toString(), isNew: false });
    }
    state.active = 0;
    state.theme = -1;
    updateSplitVisibility();
    render();
    writeProps();
  };

  // On first load the Dates mode can appear selected straight from the default
  // markup WITHOUT bbMemorySync(true)/render() ever having run — so #mb-occasions
  // stays empty until you switch to another type and back. If Dates is the
  // selected + visible mode and the inspiration tiles are missing, activate it
  // (which renders them). Guarded on "empty" so it's idempotent and never
  // disturbs a panel the customer is already filling in.
  function ensureDatesInspiration() {
    // Render the date inspiration tiles whenever the Dates mode is VISIBLE (it's the
    // default on load) — not only when the card is selected. With deferred selection
    // nothing is selected initially, so the old "is-selected" guard left them blank.
    if (memoryMode && !memoryMode.hidden && occWrap && occWrap.children.length === 0) {
      if (window.bbMemorySync) window.bbMemorySync(true);
    }
  }
  requestAnimationFrame(ensureDatesInspiration);
  [150, 500, 1000, 1600].forEach(function (d) { setTimeout(ensureDatesInspiration, d); });
})();

// ─── STEP 3 — "NAMES" (name + optional anecdote, mirrors Remember-when) ───
(function() {
  var nameLine     = document.getElementById('mb-name-line');
  var nameCount    = document.getElementById('mb-name-count');
  var anecLine     = document.getElementById('mb-anecdote-line');
  var anecCount    = document.getElementById('mb-anecdote-count');
  var nameLabel    = document.getElementById('mb-name-label');
  var anecFoot     = document.getElementById('mb-anecdote-foot');
  var sixRow       = document.getElementById('mb-names-six-row');
  var sixCheckbox  = document.getElementById('mb-names-six-checkbox');
  var sixWord      = document.getElementById('mb-names-six-word');
  var nav          = document.getElementById('mb-names-nav');
  var navPrev      = document.getElementById('mb-names-prev');
  var navNext      = document.getElementById('mb-names-next');
  var navIndicator = document.getElementById('mb-names-indicator');
  var nameHidden   = document.getElementById('mb-name-input');
  var anecHidden   = document.getElementById('mb-anecdote-input');
  var namesHidden  = document.getElementById('mb-names-input');
  var formatHidden = document.getElementById('mb-format-input');
  var overlayTop   = document.getElementById('mb-preview-overlay-top');
  var overlayBottom= document.getElementById('mb-preview-overlay-bottom');
  if (!nameLine || !anecLine) return;

  var perBarActive = false;  // "a name on each bar" tick on/off
  var namesActive  = false;  // Names panel currently selected
  var entries = [];          // [{ name, anecdote }] one per bar
  var current = 0;

  // Placeholder suggestions — a different name + anecdote per bar as you click
  // through, so each empty bar shows its own example.
  var SAMPLE_NAMES = ['James','Sarah','Olivia','Tom','Priya','Leo','Mia','Noah','Ava','Jack','Freya','Oscar'];
  var SAMPLE_ANECS = ['Always loses at cards','Makes the best roast','Terrible at darts','Coffee before words','Proudly a dog person','Never knowingly on time','Karaoke legend','Reads three books a week','Secretly hates coriander','Always picks the music','World-class hugger','Tells the worst jokes'];
  var DEFAULT_NAME_PH = 'James';
  var DEFAULT_ANEC_PH = 'Always loses at cards';
  function setPlaceholders(i) {
    nameLine.placeholder = SAMPLE_NAMES[i % SAMPLE_NAMES.length];
    anecLine.placeholder = SAMPLE_ANECS[i % SAMPLE_ANECS.length];
  }

  var NUM_WORDS = { 6: 'six', 12: 'twelve' };
  var ORD = ['one','two','three','four','five','six','seven','eight','nine','ten','eleven','twelve'];

  function bbBoxSize() {
    var sel = document.querySelector('.bb-size-card.selected');
    return sel ? parseInt(sel.dataset.size, 10) : 6;
  }
  function ensureEntries(n) {
    while (entries.length < n) entries.push({ name: '', anecdote: '' });
  }
  function saveCurrentEntry() {
    ensureEntries(current + 1);
    entries[current] = { name: nameLine.value, anecdote: anecLine.value };
  }
  function loadEntryIntoInputs(i) {
    ensureEntries(i + 1);
    var e = entries[i] || { name: '', anecdote: '' };
    setPlaceholders(i);
    nameLine.value = e.name || '';
    anecLine.value = e.anecdote || '';
    if (nameCount) nameCount.textContent = nameLine.value.length;
    if (anecCount) anecCount.textContent = anecLine.value.length;
  }
  function updateIndicator() {
    var n = bbBoxSize();
    if (navIndicator) navIndicator.textContent = (current + 1) + ' / ' + n;
    if (navPrev) navPrev.disabled = current === 0;
    if (navNext) navNext.disabled = current === n - 1;
  }
  function updateFoot() {
    if (!anecFoot) return;
    anecFoot.textContent = perBarActive
      ? 'Each bar gets its own name and anecdote.'
      : ('This will appear on all ' + bbBoxSize() + ' of your bars');   // bbBoxSize() is in this IIFE's scope; selectedSize is NOT (it lives in the main IIFE) → was throwing a ReferenceError that killed the whole names controller
  }
  function updateNameLabel() {
    if (!nameLabel) return;
    nameLabel.textContent = perBarActive ? ('Name ' + (ORD[current] || (current + 1))) : 'Their name';
  }
  function publishState() {
    window.bbStoryState = window.bbStoryState || {};
    if (window.bbStoryState.namesPerBar !== perBarActive) {
      window.bbStoryState.namesPerBar = perBarActive;
      if (window.bbRefreshForStory) window.bbRefreshForStory();
    }
  }
  // The tick box shows whenever Names is active (works on both 6 and 12); the
  // label word tracks the box size.
  function updateVisibility() {
    if (sixRow) sixRow.hidden = !namesActive;
    if (sixWord) sixWord.textContent = NUM_WORDS[bbBoxSize()] || String(bbBoxSize());
    if (nav) nav.hidden = !(namesActive && perBarActive);
    updateFoot();
    updateNameLabel();
    publishState();
  }
  function refreshPreviewFromInputs() {
    if (nameCount) nameCount.textContent = nameLine.value.length;
    if (anecCount) anecCount.textContent = anecLine.value.length;
    if (overlayTop) overlayTop.textContent = nameLine.value || nameLine.placeholder || 'James';
    if (overlayBottom) overlayBottom.textContent = anecLine.value || anecLine.placeholder || '';
  }
  function writePerBarProps() {
    var n = bbBoxSize();
    ensureEntries(n);
    var parts = [];
    for (var i = 0; i < n; i++) {
      var e = entries[i] || { name: '', anecdote: '' };
      var nm = window.bbCpSlice((e.name || '').trim(), 10);
      var an = window.bbCpSlice((e.anecdote || '').trim(), 40);
      if (nm || an) parts.push((nm || '—') + ' – ' + (an || (nm ? 'no message' : '')));
    }
    if (namesHidden) namesHidden.value = window.bbCpSlice(parts.join(' | '), 255);
    if (nameHidden)  nameHidden.value  = '';
    if (anecHidden)  anecHidden.value  = '';
  }
  // Flag the Names story so effectiveVariant() picks the Names variant (mirrors dates' applyStoryPricing).
  function applyNamesPricing(hasContent) {
    window.bbStoryState = window.bbStoryState || {};
    var on = hasContent || !!document.querySelector('.bb-opt2-card[data-opt2="name"].is-selected');
    var want = on ? 'Names' : null;
    if (window.bbStoryState.story !== want) {
      window.bbStoryState.story = want;
      if (window.bbRefreshForStory) window.bbRefreshForStory();
    }
    if (hasContent && window.bbSelectOpt2Card) window.bbSelectOpt2Card('name');
    // Reprice on EVERY call, not only story TRANSITIONS: the card click sets story before any content
    // exists (base price shown), and typing afterwards never changed the story again — so the CTA price
    // stayed stale on name-only. bbRefreshForStory = syncForm + CTA price + buttons + delivery.
    if (window.bbRefreshForStory) window.bbRefreshForStory();
    else if (window.bbUpdateButtons) window.bbUpdateButtons();
  }
  function syncNamesProps(active) {
    namesActive = !!active;
    if (overlayTop) overlayTop.classList.toggle('is-dotev', namesActive);
    updateVisibility();
    if (!namesActive) {
      if (nameHidden)  nameHidden.value  = '';
      if (anecHidden)  anecHidden.value  = '';
      if (namesHidden) namesHidden.value = '';
      return;
    }
    refreshPreviewFromInputs();
    if (perBarActive) {
      saveCurrentEntry();
      writePerBarProps();
      applyNamesPricing(!!(namesHidden && namesHidden.value.trim()));
    } else {
      if (nameHidden)  nameHidden.value  = nameLine.value;
      if (anecHidden)  anecHidden.value  = anecLine.value || ((nameLine.value || '').trim() ? 'no message' : '');
      if (namesHidden) namesHidden.value = '';
      applyNamesPricing(!!(nameLine && nameLine.value.trim()));
    }
    if (window.bbGiftRender) window.bbGiftRender();   // repaint the preview from the just-written props
  }
  window.bbNamesSync = syncNamesProps;
  // Submit-time recovery: rebuild _Names from the entries[] model. syncNamesProps(false) clears the
  // hidden inputs on mode switches, and if no later sync runs before submit the order arrives with the
  // Names variant but NO names (order BB19538). syncForm calls this when it detects that state.
  window.bbNamesResync = function () {
    if (namesActive && perBarActive) { saveCurrentEntry(); writePerBarProps(); }
  };
  // Single: name + message. Per-bar: every bar needs both a name and a message.
  // Message OPTIONAL (Barney 2026-08-07): a name alone is a legitimate purchase — the bar prints the
  // name and the order says "no message". Single: name required. Per-bar: every bar needs a name.
  window.bbNamesComplete = function () {
    if (!perBarActive) {
      return !!((nameLine.value || '').trim());
    }
    var need = bbBoxSize();
    for (var i = 0; i < need; i++) {
      var nm;
      if (i === current) { nm = nameLine.value; }   // current bar = live inputs
      else { var e = entries[i] || {}; nm = e.name; }
      if (!((nm || '').trim())) return false;
    }
    return true;
  };

  function setPerBar(on) {
    if (on) {
      ensureEntries(bbBoxSize());
      saveCurrentEntry();
      perBarActive = true;
      setPlaceholders(current);
      if (sixCheckbox) sixCheckbox.classList.add('checked');
    } else {
      perBarActive = false;
      nameLine.placeholder = DEFAULT_NAME_PH;
      anecLine.placeholder = DEFAULT_ANEC_PH;
      if (sixCheckbox) sixCheckbox.classList.remove('checked');
    }
    if (nav) nav.hidden = !perBarActive;
    updateIndicator();
    updateFoot();
    updateNameLabel();
    syncNamesProps(namesActive);
  }
  function gotoEntry(i) {
    saveCurrentEntry();
    var n = bbBoxSize();
    current = Math.max(0, Math.min(n - 1, i));
    loadEntryIntoInputs(current);
    updateNameLabel();
    updateIndicator();
    syncNamesProps(namesActive);
  }

  if (sixRow) sixRow.addEventListener('click', function() { setPerBar(!perBarActive); });
  if (navPrev) navPrev.addEventListener('click', function() { gotoEntry(current - 1); });
  if (navNext) navNext.addEventListener('click', function() { gotoEntry(current + 1); });
  document.querySelectorAll('.bb-size-card').forEach(function(c) {
    c.addEventListener('click', function() {
      setTimeout(function() {
        var n = bbBoxSize();
        if (current > n - 1) current = n - 1;
        ensureEntries(n);
        if (namesActive) syncNamesProps(true); else updateVisibility();
        updateIndicator();
      }, 0);
    });
  });
  nameLine.addEventListener('input', function() { syncNamesProps(true); });
  anecLine.addEventListener('input', function() { syncNamesProps(true); });

  // Inactive until the Names card is selected.
  syncNamesProps(false);

  // Prefill the Names panel from the homepage AI builder (one {name,anecdote} per bar).
  window.bbNamesPrefill = function (list) {
    list = list || [];
    namesActive = true;
    setPerBar(true);                       // a name on each bar
    var n = bbBoxSize();
    ensureEntries(n);
    for (var i = 0; i < n; i++) {
      var e = list[i] || {};
      entries[i] = { name: (e.name || '').toString(), anecdote: (e.anecdote || '').toString() };
    }
    current = 0;
    loadEntryIntoInputs(0);
    updateIndicator(); updateNameLabel(); updateVisibility();
    syncNamesProps(true);
  };

  // Gifting six-loops: after the AI fills the six per-bar DOM fields, sync entries[] FROM them and
  // write the props — so writePerBarProps agrees with what's shown (it was overwriting mb-names-input
  // with the single-entry model). Does NOT touch the original single inputs.
  window.bbNamesSyncFromBars = function () {
    var names = [].slice.call(document.querySelectorAll('#mb-names-perbar .mb-bar-name'));
    var msgs  = [].slice.call(document.querySelectorAll('#mb-names-perbar .mb-bar-msg'));
    if (!names.length) return;
    var n = bbBoxSize();
    ensureEntries(n);
    perBarActive = true; namesActive = true;
    for (var i = 0; i < n; i++) {
      entries[i] = { name: (names[i] ? names[i].value : ''), anecdote: (msgs[i] ? msgs[i].value : '') };
    }
    writePerBarProps();
    if (window.bbGiftRender) window.bbGiftRender();
  };
})();

// ─── STEP 3 — "TELL A STORY" CHAPTERS ────────────────────────────────
(function() {
  var storyMode      = document.getElementById('mb-story-mode');
  var chapterInput   = document.getElementById('mb-chapter-line');
  var chapterCount   = document.getElementById('mb-chapter-count');
  var chapterLabel   = document.getElementById('mb-chapter-label');
  var chapterPrompt  = document.getElementById('mb-chapter-prompt');
  var nav            = document.getElementById('mb-chapter-nav');
  var indicator      = document.getElementById('mb-chapter-indicator');
  var prevBtn        = document.getElementById('mb-chapter-prev');
  var nextBtn        = document.getElementById('mb-chapter-next');
  var chaptersHidden = document.getElementById('mb-chapters-input');
  var overlayTop     = document.getElementById('mb-preview-overlay-top');
  var overlayBottom  = document.getElementById('mb-preview-overlay-bottom');
  if (!chapterInput || !nav) return;

  var chapters = [];  // one entry per bar/chapter
  var current = 0;    // 0-based index
  var active = false;

  // Per-chapter guide: heading numeral, prompt line, and example placeholder
  var PROMPTS      = ['Once upon a time…', 'Then…', 'Soon after…', 'The big moment…', 'And then…', 'The best chapter yet…'];
  var PLACEHOLDERS = ['We met at university', 'We went on our first holiday', 'We moved in together', 'I proposed', 'We got married', 'Otto arrived'];
  var ROMAN        = ['I','II','III','IV','V','VI','VII','VIII','IX','X','XI','XII'];
  function roman(n)        { return ROMAN[n - 1] || String(n); }
  function promptFor(i)    { return PROMPTS[i] || ''; }
  function placeholderFor(i) { return PLACEHOLDERS[i] || 'Your chapter'; }

  function boxSize() {
    var sel = document.querySelector('.bb-size-card.selected');
    var n = sel ? parseInt(sel.dataset.size, 10) : 6;
    return (n === 12) ? 12 : 6;
  }
  function resizeChapters(n) {
    while (chapters.length < n) chapters.push('');
    if (chapters.length > n) chapters.length = n;
    if (current > n - 1) current = n - 1;
    if (current < 0) current = 0;
  }
  // Flag the "Tell a story" (Chapters) story so effectiveVariant() picks the Chapters variant.
  function applyChaptersPricing(hasContent) {
    window.bbStoryState = window.bbStoryState || {};
    var on = hasContent || !!document.querySelector('.bb-opt2-card[data-opt2="chapter"].is-selected');
    var want = on ? 'Tell a story' : null;
    if (window.bbStoryState.story !== want) {
      window.bbStoryState.story = want;
      if (window.bbRefreshForStory) window.bbRefreshForStory();
    }
    if (hasContent && window.bbSelectOpt2Card) window.bbSelectOpt2Card('chapter');
    if (window.bbUpdateButtons) window.bbUpdateButtons();  // re-validate express/add on content change
  }
  window.bbApplyChaptersPricing = applyChaptersPricing;   // let the snippet's story sync price the chapter option
  function writeChaptersProp() {
    if (!chaptersHidden) return;
    if (!active) { chaptersHidden.value = ''; return; }
    var parts = [];
    chapters.forEach(function(txt, i) {
      var v = window.bbCpSlice((txt || '').trim(), 40);
      if (v) parts.push('Ch' + (i + 1) + ': ' + v);
    });
    chaptersHidden.value = window.bbCpSlice(parts.join(' | '), 255);
    applyChaptersPricing(parts.length > 0);
  }
  function render() {
    var n = chapters.length;
    if (chapterLabel) chapterLabel.textContent = 'Chapter ' + (current + 1);
    if (chapterPrompt) chapterPrompt.textContent = promptFor(current);
    chapterInput.placeholder = placeholderFor(current);
    chapterInput.value = chapters[current] || '';
    if (chapterCount) chapterCount.textContent = chapterInput.value.length;
    if (indicator) indicator.textContent = (current + 1) + ' / ' + n;
    if (prevBtn) prevBtn.disabled = current === 0;
    if (nextBtn) nextBtn.disabled = current === n - 1;
    if (overlayTop) overlayTop.textContent = 'Chapter ' + (current + 1);
    if (overlayBottom) overlayBottom.textContent = chapters[current] || chapterInput.placeholder || '';
    autoGrow();
    writeChaptersProp();
  }
  function autoGrow() {
    // Reset then size to content so the field expands to a second line
    // when the text fills, and shrinks back when short.
    chapterInput.style.height = 'auto';
    chapterInput.style.height = chapterInput.scrollHeight + 'px';
  }
  function sync(isActive) {
    active = !!isActive;
    if (storyMode) storyMode.hidden = !active;
    nav.hidden = !active;
    if (active) { resizeChapters(boxSize()); render(); }
    else { writeChaptersProp(); }
  }
  window.bbStorySync = sync;
  // Every chapter (one per bar) must be filled in.
  window.bbChaptersComplete = function () {
    var need = boxSize();
    for (var i = 0; i < need; i++) {
      var v = (i === current) ? chapterInput.value : chapters[i];   // current chapter = live input
      if (!((v || '').trim())) return false;
    }
    return true;
  };

  chapterInput.addEventListener('input', function() {
    chapters[current] = chapterInput.value;
    if (chapterCount) chapterCount.textContent = chapterInput.value.length;
    if (overlayBottom) overlayBottom.textContent = chapterInput.value || chapterInput.placeholder || '';
    autoGrow();
    writeChaptersProp();
  });
  chapterInput.addEventListener('keydown', function(e) { if (e.key === 'Enter') e.preventDefault(); });
  if (prevBtn) prevBtn.addEventListener('click', function() {
    chapters[current] = chapterInput.value;
    if (current > 0) { current--; render(); }
  });
  if (nextBtn) nextBtn.addEventListener('click', function() {
    chapters[current] = chapterInput.value;
    if (current < chapters.length - 1) { current++; render(); }
  });

  // Keep the chapter count in step with the box size if it changes mid-flow
  document.querySelectorAll('.bb-size-card').forEach(function(card) {
    card.addEventListener('click', function() {
      if (!active) return;
      setTimeout(function() { resizeChapters(boxSize()); render(); }, 0);
    });
  });

  // Prefill the chapters from the homepage AI builder (one line per bar).
  window.bbStoryPrefill = function (lines) {
    lines = lines || [];
    active = true;
    if (storyMode) storyMode.hidden = false;
    nav.hidden = false;
    resizeChapters(boxSize());
    for (var i = 0; i < chapters.length; i++) chapters[i] = (lines[i] || '').toString();
    current = 0;
    render();
  };
})();

// ─── STEP 3 — ADD YOUR STORY (select + reveal panel) ─────────────────
(function() {
  var grid = document.getElementById('bb-story-grid');
  var input = document.getElementById('bb-story-input');
  var panel = document.getElementById('bb-remember-when-panel');
  var memoryMode = document.getElementById('mb-memory-mode');
  var namesMode = document.getElementById('mb-names-mode');
  var revertBtn = document.getElementById('bb-story-revert');
  if (!grid) return;

  // mode: 'memory' | 'story' | 'names' | null
  function setMode(mode) {
    if (panel) panel.classList.toggle('is-open', mode === 'memory' || mode === 'story' || mode === 'names');
    if (memoryMode) memoryMode.hidden = (mode !== 'memory');
    if (namesMode) namesMode.hidden = (mode !== 'names');
    if (window.bbMemorySync) window.bbMemorySync(mode === 'memory');
    if (window.bbStorySync) window.bbStorySync(mode === 'story');
    if (window.bbNamesSync) window.bbNamesSync(mode === 'names');
  }

  // Push the chosen story (or null) into the pricing engine + refresh CTA/variant/delivery
  function applyStory(story) {
    window.bbStoryState = window.bbStoryState || {};
    window.bbStoryState.story = (story === 'Remember when' || story === 'Tell a story' || story === 'Names') ? story : null;
    if (revertBtn) revertBtn.hidden = !window.bbStoryState.story; // show only while personalising
    if (window.bbRefreshForStory) window.bbRefreshForStory();
  }

  // Strip the Step 3 layer and return to the plain box (keeps the chosen flavours)
  function clearStory() {
    if (window.bbTrackRevertedIfFilled) window.bbTrackRevertedIfFilled();   // Journey Intelligence: undo of a filled personalisation
    grid.querySelectorAll('.bb-story-card').forEach(function(c) { c.classList.remove('selected'); });
    if (input) input.value = '';
    setMode(null);
    applyStory(null);
  }
  if (revertBtn) revertBtn.addEventListener('click', clearStory);

  // Single-select, toggleable off (the step is optional, no default)
  grid.querySelectorAll('.bb-story-card').forEach(function(card) {
    card.addEventListener('click', function() {
      if (card.classList.contains('is-disabled')) return; // e.g. Tell a story on box of 12
      var alreadyOn = card.classList.contains('selected');
      grid.querySelectorAll('.bb-story-card').forEach(function(c) { c.classList.remove('selected'); });
      if (alreadyOn) {
        if (input) input.value = '';
        setMode(null);
        applyStory(null);
      } else {
        card.classList.add('selected');
        if (input) input.value = card.dataset.story || '';
        var story = card.dataset.story;
        setMode(story === 'Remember when' ? 'memory' : (story === 'Tell a story' ? 'story' : (story === 'Names' ? 'names' : null)));
        applyStory(story);
      }
    });
  });

  // ── Tell a story is only available with the box of 6 ───────────────
  var tellCard = grid.querySelector('.bb-story-card[data-story="Tell a story"]');
  var tellNote = document.getElementById('bb-story-note-tell');
  function boxSize() {
    var sel = document.querySelector('.bb-size-card.selected');
    return sel ? parseInt(sel.dataset.size, 10) : 6;
  }
  function updateTellAvailability() {
    var disabled = false;   // Chapters now available on box 6 AND box 12
    if (tellCard) tellCard.classList.toggle('is-disabled', disabled);
    if (tellNote) tellNote.hidden = !disabled;
    // If it was selected and is now disabled, drop the selection + close the panel
    if (disabled && tellCard && tellCard.classList.contains('selected')) {
      tellCard.classList.remove('selected');
      if (input) input.value = '';
      setMode(null);
      applyStory(null);
    }
  }
  document.querySelectorAll('.bb-size-card').forEach(function(c) {
    c.addEventListener('click', function() { setTimeout(updateTellAvailability, 0); });
  });
  updateTellAvailability();

  // Links without an href yet stay inert; wired links navigate normally
  var section = grid.closest('.bb-story-section');
  if (section) {
    section.querySelectorAll('.bb-story-link').forEach(function(a) {
      a.addEventListener('click', function(e) {
        if (!a.getAttribute('href')) e.preventDefault();
      });
    });
  }
})();

// ─── AD PERSONALISATION ──────────────────────────
(function() {
  var params = new URLSearchParams(window.location.search);
  var adKey = params.get('ad');
  var config = (adKey && window.adConfigs && window.adConfigs[adKey]) ? window.adConfigs[adKey] : null;

if (config) {
    // Ad-landing headline uses Utile Display; text swapped to the ad's headline.
    var pageTitle = document.querySelector('.bb-page-title');
    if (pageTitle) {
      pageTitle.style.fontFamily = "'Utile Display', 'Cormorant Garamond', serif";
      if (config.headline) pageTitle.innerHTML = config.headline;   // honour <br> in the headline (same trust level as the subtitle below — ad-config, not shopper input)
    }
    if (config.subtitle) {
      var subtitle = document.querySelector('.bb-page-subtitle');
      if (subtitle) subtitle.innerHTML = config.subtitle;
    }
    if (window.bbRevealTitle) window.bbRevealTitle();   // static-config path: ad headline applied → reveal

    // Gender ONLY the box/bars headings: "Choose your box" → "Choose her box"
    // and "Choose your bars" → "Choose her bars". Everything else (e.g. "Add your
    // story") is left untouched. pronoun ∈ 'her' | 'his' | 'their'.
    if (config.pronoun && config.pronoun !== 'your') {
      var pr = config.pronoun;
      document.querySelectorAll('.bb-step-heading').forEach(function (h) {
        if (!/choose your/i.test(h.textContent)) return;
        [].forEach.call(h.childNodes, function (n) {
          if (n.nodeType === 3 && /\byour\b/i.test(n.nodeValue)) {
            n.nodeValue = n.nodeValue.replace(/\byour\b/gi, pr);
          }
        });
      });
    }

    // Move social proof to the top of the page for ad traffic — but NOT on the real
    // gifting page (its gift hero should lead; the trophy/stars stay in the bottom
    // trust row there, matching the build-your-box page).
    var socialProofEl = document.querySelector('.bb-social-proof');
    var bbPage = document.querySelector('.bb-page');
    var proofMovedTop = false;
    if (socialProofEl && bbPage && !bbPage.classList.contains('bb-page--giftpage')) {
      proofMovedTop = true;
      socialProofEl.style.marginTop = '26px';
      socialProofEl.style.marginBottom = '0px';
      // .bb-trust__reviews is display:flex + text-align:left for the bottom trust row; at the TOP of an
      // ad page the stars + text should sit centred, so override the flex justification here.
      socialProofEl.style.justifyContent = 'center';
      socialProofEl.style.textAlign = 'center';
      // Mobile hides .bb-trust__reviews (≤749px: the stars live BELOW the payment card
      // instead) — but at the TOP of an ad landing the line must show on every viewport,
      // so force it past that media rule (Barney 2026-08-29: stars missing on mobile).
      socialProofEl.style.setProperty('display', 'flex', 'important');
      bbPage.insertBefore(socialProofEl, bbPage.firstChild);
    }

// Carousel takes precedence if defined, otherwise fall back to single hero image
    if (config.carousel && config.carousel.length > 0) {
      var headerForCarousel = document.querySelector('.bb-page-header');
      if (headerForCarousel) {
        var carousel = buildCarousel(config.carousel);
        headerForCarousel.parentNode.insertBefore(carousel, headerForCarousel);
      }
    } else if (config.heroImage) {
      var header = document.querySelector('.bb-page-header');
      if (header) {
        var img = document.createElement('img');
        img.src = config.heroImage;
        img.style.cssText = 'width:100%;display:block;margin-bottom:12px;margin-top:30px;';
        header.parentNode.insertBefore(img, header);
      }
    }

    // Cart image — only store if explicitly set
    if (config.cartImage) {
      sessionStorage.setItem('bb_cart_image', config.cartImage);
    }

    // Swap social proof. When it sits at the TOP of an ad landing, the stars go on
    // their OWN line above the text (Barney 2026-08-29) — the element is flex, so
    // stack it and rebuild as two spans (stars keep the gold class).
    if (config.socialProof) {
      var proof = document.querySelector('.bb-social-proof');
      if (proof) {
        var mSP = proofMovedTop ? config.socialProof.match(/^([★☆]+)\s*(.+)$/) : null;
        if (mSP) {
          proof.style.flexDirection = 'column';
          proof.style.alignItems = 'center';
          proof.style.gap = '3px';
          proof.innerHTML = '';
          var spStars = document.createElement('span'); spStars.className = 'bb-social-proof__stars'; spStars.textContent = mSP[1];
          var spTxt = document.createElement('span'); spTxt.textContent = mSP[2];
          proof.appendChild(spStars); proof.appendChild(spTxt);
        } else {
          proof.textContent = config.socialProof;
        }
      }
    }
  }

  // ─── CAROUSEL BUILDER ───────────────────────────
  function buildCarousel(images) {
    var wrap = document.createElement('div');
    wrap.style.cssText = 'width:100%;margin-top:30px;margin-bottom:12px;';

    var main = document.createElement('div');
    main.style.cssText = 'position:relative;width:100%;overflow:hidden;aspect-ratio:3/2;border-radius:4px;';

    var track = document.createElement('div');
    track.style.cssText = 'display:flex;transition:transform 0.35s ease;will-change:transform;height:100%;';

    images.forEach(function(src, i) {
      var slide = document.createElement('div');
      slide.style.cssText = 'flex:0 0 100%;width:100%;height:100%;';
      var img = document.createElement('img');
      img.src = src;
      img.alt = '';
      img.loading = i === 0 ? 'eager' : 'lazy';
      img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';
      slide.appendChild(img);
      track.appendChild(slide);
    });

    main.appendChild(track);
    wrap.appendChild(main);

    // Thumbnail row
    var thumbs = document.createElement('div');
    thumbs.style.cssText = 'display:flex;justify-content:center;gap:2px;margin-top:3px;';
    var thumbButtons = [];

    images.forEach(function(src, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('aria-label', 'View image ' + (i + 1));
      btn.style.cssText = 'padding:0;border:1.5px solid ' + (i === 0 ? '#fece62' : 'transparent') + ';border-radius:4px;background:transparent;cursor:pointer;overflow:hidden;width:56px;height:56px;flex-shrink:0;transition:border-color 0.2s,opacity 0.2s;opacity:' + (i === 0 ? '1' : '0.55') + ';';
      var thumbImg = document.createElement('img');
      thumbImg.src = src;
      thumbImg.alt = '';
      thumbImg.loading = 'lazy';
      thumbImg.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';
      btn.appendChild(thumbImg);
      btn.addEventListener('click', function() { goTo(i); });
      thumbs.appendChild(btn);
      thumbButtons.push(btn);
    });

    wrap.appendChild(thumbs);

    // Navigation state
    var current = 0;
    var total = images.length;

    function goTo(i) {
      current = Math.max(0, Math.min(total - 1, i));
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      thumbButtons.forEach(function(b, idx) {
        b.style.borderColor = idx === current ? '#fece62' : 'transparent';
        b.style.opacity = idx === current ? '1' : '0.55';
      });
    }

    // Touch / swipe
    var startX = 0, deltaX = 0, dragging = false;
    var SWIPE_THRESHOLD = 40;

    main.addEventListener('touchstart', function(e) {
      dragging = true;
      startX = e.touches[0].clientX;
      deltaX = 0;
      track.style.transition = 'none';
    }, { passive: true });

    main.addEventListener('touchmove', function(e) {
      if (!dragging) return;
      deltaX = e.touches[0].clientX - startX;
      var basePct = -current * 100;
      var dragPct = (deltaX / main.offsetWidth) * 100;
      track.style.transform = 'translateX(' + (basePct + dragPct) + '%)';
    }, { passive: true });

    main.addEventListener('touchend', function() {
      if (!dragging) return;
      dragging = false;
      track.style.transition = '';
      if (deltaX < -SWIPE_THRESHOLD && current < total - 1) {
        goTo(current + 1);
      } else if (deltaX > SWIPE_THRESHOLD && current > 0) {
        goTo(current - 1);
      } else {
        goTo(current);
      }
    });

    return wrap;
  }

  // ─── REORDER FLAVOUR CARDS (runs whether ad active or not) ──
  // Anchor flavour: ad flavour if available, else Peanut Butter as default.
  var anchorFlavour = (config && config.flavour) ? config.flavour : 'Peanut Butter';

  setTimeout(function() {
    var grid = document.getElementById('bb-flavour-grid');
    if (!grid) return;

    var allChildren = Array.prototype.slice.call(grid.children);

    var specialCards = allChildren.filter(function(c) {
      return c.id === 'bb-special-card'
          || c.id === 'bb-special-offweek'
          || c.classList.contains('bb-special-offweek')
          || c.classList.contains('bb-flavour-card--locked');
    });

    var realCards = allChildren.filter(function(c) {
      return c.dataset.flavour && specialCards.indexOf(c) === -1;
    });

    var anchorCard = realCards.filter(function(c) {
      return c.dataset.flavour === anchorFlavour;
    })[0];
    var rest = realCards.filter(function(c) { return c !== anchorCard; });

    function qtyOf(card) {
      var el = card.querySelector('.bb-qty-num');
      return el ? parseInt(el.textContent, 10) || 0 : 0;
    }

    var selected = rest.filter(function(c) { return qtyOf(c) > 0; });
    var unselected = rest.filter(function(c) { return qtyOf(c) === 0; });

    var ordered = [];

    if (anchorCard) {
      ordered.push(anchorCard);
      if (selected.length) {
        ordered.push(selected.shift());
      } else if (unselected.length) {
        ordered.push(unselected.shift());
      }
    }

    var rowIndex = 1;
    while (selected.length || unselected.length) {
      var selectedFirst = (rowIndex % 2 === 1);
      var leftCard, rightCard;

      if (selected.length && unselected.length) {
        if (selectedFirst) {
          leftCard = unselected.shift();
          rightCard = selected.shift();
        } else {
          leftCard = selected.shift();
          rightCard = unselected.shift();
        }
      } else if (selected.length >= 2) {
        leftCard = selected.shift();
        rightCard = selected.shift();
      } else if (selected.length === 1) {
        leftCard = selected.shift();
        rightCard = null;
      } else if (unselected.length >= 2) {
        break;
      } else if (unselected.length === 1) {
        leftCard = unselected.shift();
        rightCard = null;
      }

      if (leftCard) ordered.push(leftCard);
      if (rightCard) ordered.push(rightCard);
      rowIndex++;
    }

    while (unselected.length) ordered.push(unselected.shift());

    ordered.forEach(function(card) { grid.appendChild(card); });
    specialCards.forEach(function(card) { grid.appendChild(card); });
  }, 50);

})();

// ─── PREFILL FROM HOMEPAGE AI BUILDER ────────────────────────────────
// "Edit in builder" on the homepage stashes the AI box in localStorage
// (key 'bb_ai_box') and lands here. Apply it: box size, flavours, and the
// chosen personalisation mode + per-bar content, then clear the key.
(function () {
  var STORE_KEY = 'bb_ai_box';
  var STORY_FOR = { story: 'Tell a story', names: 'Names', dates: 'Remember when' };

  function setFlavours(flavours) {
    var counts = {};
    (flavours || []).forEach(function (f) { counts[f] = (counts[f] || 0) + 1; });
    var cards = document.querySelectorAll('.bb-flavour-card:not(.bb-flavour-card--locked)');
    // zero everything the default prefill put in
    cards.forEach(function (card) {
      var num = card.querySelector('.bb-qty-num'), minus = card.querySelector('.bb-minus'), guard = 30;
      while (num && minus && parseInt(num.textContent, 10) > 0 && guard-- > 0) minus.click();
    });
    // add up to each flavour's target
    cards.forEach(function (card) {
      var target = counts[card.dataset.flavour] || 0;
      var num = card.querySelector('.bb-qty-num'), plus = card.querySelector('.bb-plus'), guard = 30;
      while (num && plus && parseInt(num.textContent, 10) < target && guard-- > 0) plus.click();
    });
  }

  function fillContent(data) {
    var bars = data.bars || [];
    if (data.mode === 'story' && window.bbStoryPrefill) {
      window.bbStoryPrefill(bars.map(function (b) { return (b.bottom || b.top || ''); }));
    } else if (data.mode === 'names' && window.bbNamesPrefill) {
      window.bbNamesPrefill(bars.map(function (b) { return { name: (b.top || ''), anecdote: (b.bottom || '') }; }));
    } else if (data.mode === 'dates' && window.bbDatesPrefill) {
      window.bbDatesPrefill(bars.map(function (b) { return { date: (b.top || ''), label: (b.bottom || '') }; }));
    }
    if (window.bbGiftRender) window.bbGiftRender();
  }

  // Apply an AI-box result to this on-page builder. Exposed globally so an embedded
  // AI box (e.g. on the gifting page) can prefill in place instead of navigating here.
  function applyData(data) {
    if (!data || !Array.isArray(data.bars)) return;

    var count = data.count === 12 ? 12 : 6;

    // 1) box size (clicking applies a default flavour prefill we then overwrite)
    var sizeCard = document.querySelector('.bb-size-card[data-size="' + count + '"]');
    if (sizeCard) sizeCard.click();

    // 2) flavours
    setFlavours(data.flavours);

    // 3) personalisation mode + per-bar content
    var storyName = STORY_FOR[data.mode];
    var card = storyName ? document.querySelector('.bb-story-card[data-story="' + storyName + '"]') : null;
    if (card && !card.classList.contains('is-disabled')) {
      card.click();
      setTimeout(function () {
        fillContent(data);
        card.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 40);
    }
  }
  window.bbApplyAiBox = applyData;

  function run() {
    var raw;
    try { raw = localStorage.getItem(STORE_KEY); } catch (e) { return; }
    if (!raw) return;
    try { localStorage.removeItem(STORE_KEY); } catch (e) {}
    var data;
    try { data = JSON.parse(raw); } catch (e) { return; }
    applyData(data);
  }

  // Run after the builder's own init has wired everything up.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(run, 0); });
  } else {
    setTimeout(run, 0);
  }
})();

// ─── LOG MANUAL PERSONALISATION (sale or not) ────────────────────────
// Records what the customer types into Step-3 personalisation into the same
// Airtable Briefs table (Source = build-your-box). One row per session:
// created on first meaningful input, debounce-updated as they edit, flushed
// on add-to-bag + when leaving the page. The row id rides into the order via
// the _personalisation_id property so conversions reconcile.
(function () {
  var ENDPOINT = 'https://barnabydashboard.netlify.app/.netlify/functions/log-personalisation';
  var idInput = document.getElementById('bb-personalisation-id');
  var recordId = null, lastSig = '', timer = null, finalSent = false;
  var trail = [];   // every distinct personalisation version they pass through
  var seenR = {}, recipientsArr = [];   // every distinct recipient name mentioned this session
  var seenD = {}, datesArr = [];        // every distinct date+moment mentioned this session

  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  function stamp() { var d = new Date(); return pad2(d.getHours()) + ':' + pad2(d.getMinutes()); }
  function trailString() { return trail.map(function (e) { return '[' + e.t + '] ' + e.c; }).join('\n'); }

  // Track every recipient / date they pass through — even ones later changed or
  // removed — so "mentioned but not bought" survives (mum → sister keeps both).
  function recordEntities(p) {
    if (p.mode === 'names') {
      var raw = v('mb-names-input'), names = [];
      if (raw) raw.split('|').forEach(function (seg) {
        var nm = seg.replace(/^Bar\s*\d+:\s*/i, '').split(/—|–/)[0].trim();
        if (nm && nm !== '—') names.push(nm);
      });
      else { var single = v('mb-name-input'); if (single) names.push(single); }
      names.forEach(function (nm) { var k = nm.toLowerCase(); if (!seenR[k]) { seenR[k] = 1; recipientsArr.push(nm); } });
    } else if (p.mode === 'dates') {
      var rawd = v('mb-dates-input'), segs = rawd ? rawd.split('|') : [];
      if (!segs.length) { var top = v('mb-top-input'), bot = v('mb-bottom-input'); if (top || bot) segs = [top + ' – ' + bot]; }
      segs.forEach(function (seg) {
        var parts = seg.split(/—|–/), date = (parts[0] || '').trim(), label = (parts[1] || '').trim();
        var k = (date + '|' + label).toLowerCase();
        if ((date || label) && date !== '—' && !seenD[k]) { seenD[k] = 1; datesArr.push({ date: date, label: label }); }
      });
    }
  }

  function v(id) { var e = document.getElementById(id); return e ? (e.value || '').trim() : ''; }
  var lastStoryText = '';   // remember the free-text story even after it's used to generate chapters
  function gather() {
    var story = (window.bbStoryState && window.bbStoryState.story) || '';
    var mode = story === 'Tell a story' ? 'story' : (story === 'Names' ? 'names' : (story === 'Remember when' ? 'dates' : ''));
    // Capture EVERY loop input — committed per-bar fields + the live line inputs —
    // so extraction sees the whole personalisation, not just one field.
    var content = [
      v('mb-dates-input'), v('mb-names-input'), v('mb-chapters-input'),
      [v('mb-name-input'), v('mb-anecdote-input')].filter(Boolean).join(' — '),
      [v('mb-top-input'), v('mb-bottom-input')].filter(Boolean).join(' — '),
      v('mb-name-line'), v('mb-anecdote-line'), v('mb-chapter-line'), v('mb-first-occasion')
    ].filter(Boolean).join(' | ');
    // The richest free-text in the loops builder is the "Tell a story" description.
    var st = v('mb-story-builder-input');
    if (st) lastStoryText = st;
    var sizeCard = document.querySelector('.bb-size-card.selected');
    var occ = document.querySelector('.bb-occasion-btn.selected');
    return {
      mode: mode,
      boxSize: v('bb-boxsize-input') || (sizeCard ? sizeCard.dataset.size : ''),
      flavours: v('bb-step1-input'),
      occasion: occ ? (occ.dataset.occasion || '') : '',
      content: content,
      storyText: lastStoryText,
      format: v('mb-format-input')
    };
  }
  function meaningful(p) { return !!(p.content || p.mode); }   // only once they've personalised

  // Email captured from the "special" unlock (consented). Used to (A) attach to the brief and
  // (B) sync the in-progress story to this Klaviyo profile so a "finish your story" flow can fire.
  function currentEmail() {
    try { return (window.bbEmail || localStorage.getItem('bb_email') || '').trim(); }
    catch (e) { return (window.bbEmail || '').trim(); }
  }
  var KLAVIYO_PUBLIC_KEY = 'XB9FWQ', klavEventSent = false;
  function pushKlaviyo(p) {
    var email = currentEmail();
    if (!email || !meaningful(p)) return;   // only once we have a (consented) email + real content
    var props = {
      barnaby_draft_mode: p.mode || '',
      barnaby_draft_content: (p.content || '').slice(0, 800),
      barnaby_draft_story: (p.storyText || '').slice(0, 800),
      barnaby_draft_box_size: p.boxSize || '',
      barnaby_draft_flavours: p.flavours || '',
      barnaby_draft_url: location.href
    };
    var H = { 'content-type': 'application/json', 'revision': '2023-12-15' };
    // (B1) upsert the profile with the latest draft (idempotent — safe to repeat on edits).
    try {
      fetch('https://a.klaviyo.com/client/profiles/?company_id=' + KLAVIYO_PUBLIC_KEY, {
        method: 'POST', headers: H,
        body: JSON.stringify({ data: { type: 'profile', attributes: { email: email, properties: props } } })
      }).catch(function () {});
    } catch (e) {}
    // (B2) fire the trigger metric once per session — the Klaviyo flow filters on "no order since".
    if (!klavEventSent) {
      klavEventSent = true;
      try {
        fetch('https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_PUBLIC_KEY, {
          method: 'POST', headers: H,
          body: JSON.stringify({ data: { type: 'event', attributes: {
            properties: props,
            metric: { data: { type: 'metric', attributes: { name: 'Started Personalisation' } } },
            profile: { data: { type: 'profile', attributes: { email: email } } }
          } } })
        }).catch(function () {});
      } catch (e) {}
    }
  }

  function send(p, beacon) {
    var body = JSON.stringify({
      recordId: recordId, mode: p.mode, boxSize: p.boxSize, flavours: p.flavours,
      occasion: p.occasion, content: p.content, storyText: p.storyText, format: p.format,
      editTrail: trailString(),
      email: currentEmail(),           // (A) tie the brief to the (consented) email when we have it
      mentionedRecipients: recipientsArr.join(', '),
      mentionedDates: JSON.stringify(datesArr),
      final: !!beacon,                 // final flush → server runs feature extraction once
      raw: JSON.stringify(p)
    });
    if (beacon && navigator.sendBeacon) {
      try { navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'text/plain' })); } catch (e) {}
      return;
    }
    fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: body })
      .then(function (r) { return r.json(); })
      .then(function (res) { if (res && res.recordId) { recordId = res.recordId; if (idInput) idInput.value = recordId; } })
      .catch(function () {});
  }
  function maybeLog(beacon) {
    if (beacon && finalSent) return;   // extraction runs once per session
    var p = gather();
    if (!meaningful(p)) return;
    if (beacon) finalSent = true;
    recordEntities(p);
    // Keep every distinct version of the personalisation content (mum → sister,
    // each set of dates, etc.) — appended, never overwritten.
    if (p.content && (trail.length === 0 || trail[trail.length - 1].c !== p.content)) {
      trail.push({ t: stamp(), c: p.content });
      if (trail.length > 60) trail.shift();
    }
    var sig = JSON.stringify(p);
    if (!beacon && sig === lastSig) return;   // nothing changed since last send
    lastSig = sig;
    send(p, beacon);
    pushKlaviyo(p);   // (B) sync the draft to Klaviyo when we have a consented email
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(function () { maybeLog(false); }, 1500); }

  // Debounce on any builder interaction; gather()/signature keep it to real changes.
  document.addEventListener('input', schedule, true);
  document.addEventListener('change', schedule, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.bb-qty-btn, .bb-size-card, .bb-story-card, .bb-occasion-btn, .mb-dpick-sel, #mb-dates-six-row, #mb-names-six-row, #mb-chapter-prev, #mb-chapter-next, #mb-names-prev, #mb-names-next')) schedule();
  }, true);

  // Final flush on add-to-bag + when leaving the page (abandonment).
  var form = document.getElementById('bb-product-form');
  if (form) form.addEventListener('submit', function () { maybeLog(true); });
  window.addEventListener('pagehide', function () { maybeLog(true); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') maybeLog(true); });
})();

// ─── RESUME DRAFT: keep the in-progress personalisation so a returning ─────
// customer doesn't start over. Saves the loop content (+ mode/size/flavours) to
// localStorage as they type; restores it on load. Cleared on add-to-cart, and
// expires after 7 days. Defers to the homepage AI-box handoff if that's pending.
(function () {
  var KEY = 'bb_draft', MAXAGE = 7 * 24 * 60 * 60 * 1000;
  var STORY_FOR = { story: 'Tell a story', names: 'Names', dates: 'Remember when' };
  // Captured synchronously, before the AI-box handoff's deferred run() consumes it.
  var handoffPending = false; try { handoffPending = !!localStorage.getItem('bb_ai_box'); } catch (e) {}

  function v(id) { var e = document.getElementById(id); return e ? (e.value || '').trim() : ''; }
  function clearDraft() { try { localStorage.removeItem(KEY); } catch (e) {} }
  function curMode() { var s = window.bbStoryState && window.bbStoryState.story; return s === 'Tell a story' ? 'story' : (s === 'Names' ? 'names' : (s === 'Remember when' ? 'dates' : '')); }
  function curCount() { var c = document.querySelector('.bb-size-card.selected'); var n = c ? parseInt(c.dataset.size, 10) : 0; return n === 12 ? 12 : 6; }
  function flavCards() { return document.querySelectorAll('.bb-flavour-card:not(.bb-flavour-card--locked)'); }
  function readFlavours() { var a = []; [].forEach.call(flavCards(), function (c) { var num = c.querySelector('.bb-qty-num'); var n = num ? (parseInt(num.textContent, 10) || 0) : 0; for (var k = 0; k < n; k++) a.push(c.dataset.flavour); }); return a; }
  function setFlavours(flavs) {
    var counts = {}; (flavs || []).forEach(function (f) { counts[f] = (counts[f] || 0) + 1; });
    [].forEach.call(flavCards(), function (c) { var num = c.querySelector('.bb-qty-num'), minus = c.querySelector('.bb-minus'), g = 30; while (num && minus && parseInt(num.textContent, 10) > 0 && g-- > 0) minus.click(); });
    [].forEach.call(flavCards(), function (c) { var t = counts[c.dataset.flavour] || 0, num = c.querySelector('.bb-qty-num'), plus = c.querySelector('.bb-plus'), g = 30; while (num && plus && parseInt(num.textContent, 10) < t && g-- > 0) plus.click(); });
  }
  function trimTrail(arr, empty) { while (arr.length && empty(arr[arr.length - 1])) arr.pop(); return arr; }
  function readDates() {
    var raw = v('mb-dates-input'), segs = raw ? raw.split('|') : [], list = [];
    if (segs.length) segs.forEach(function (seg) { var p = seg.split(/—|–/), d = (p[0] || '').trim(); if (d === '—') d = ''; list.push({ date: d, label: (p[1] || '').trim() }); });
    else { var t = v('mb-top-input'), b = v('mb-bottom-input'); if (t || b) list.push({ date: t, label: b }); }
    return trimTrail(list, function (e) { return !e.date && !e.label; });
  }
  function readNames() {
    var raw = v('mb-names-input');
    if (raw) { var list = []; raw.split('|').forEach(function (seg) { seg = seg.replace(/^Bar\s*\d+:\s*/i, ''); var p = seg.split(/—|–/); list.push({ name: (p[0] || '').trim(), anecdote: (p[1] || '').trim() }); }); return { perBar: true, list: trimTrail(list, function (e) { return !e.name && !e.anecdote; }) }; }
    var n = v('mb-name-line') || v('mb-name-input'), a = v('mb-anecdote-line') || v('mb-anecdote-input');
    return { perBar: false, name: n, anecdote: a };
  }
  function readChapters() { return trimTrail([].map.call(document.querySelectorAll('#mb-chapters .mb-chap'), function (i) { return (i.value || '').trim(); }), function (s) { return !s; }); }

  function snapshot() {
    var mode = curMode(); if (!mode) return null;
    var p = { ts: Date.now(), count: curCount(), flavours: readFlavours(), mode: mode }, has = false;
    if (mode === 'dates') { p.dates = readDates(); has = p.dates.some(function (d) { return d.date || d.label; }); }
    else if (mode === 'names') { p.names = readNames(); has = p.names.perBar ? p.names.list.some(function (x) { return x.name || x.anecdote; }) : !!(p.names.name || p.names.anecdote); }
    else if (mode === 'story') { p.chapters = readChapters(); has = p.chapters.some(function (c) { return c; }); }
    return has ? p : null;
  }
  // ---- SAVE (debounced on any builder interaction) ----
  var saveT = null;
  function doSave() { try { var s = snapshot(); if (s) localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }
  function schedule() { clearTimeout(saveT); saveT = setTimeout(doSave, 700); }
  document.addEventListener('input', schedule, true);
  document.addEventListener('change', schedule, true);
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.bb-flavour-card, .bb-qty-btn, .bb-size-card, .bb-story-card, .mb-dpick-sel, .mb-chap, #mb-chapter-prev, #mb-chapter-next, #mb-names-prev, #mb-names-next')) schedule(); }, true);
  var form = document.getElementById('bb-product-form');
  if (form) form.addEventListener('submit', clearDraft);

  // ---- RESTORE (on load) ----
  function setVal(id, val) { var e = document.getElementById(id); if (e) { e.value = val; e.dispatchEvent(new Event('input', { bubbles: true })); e.dispatchEvent(new Event('change', { bubbles: true })); } }
  function fillMode(d) {
    if (d.mode === 'dates' && window.bbDatesPrefill) window.bbDatesPrefill(d.dates || []);
    else if (d.mode === 'story' && window.bbStoryPrefill) window.bbStoryPrefill(d.chapters || []);
    else if (d.mode === 'names') {
      if (d.names && d.names.perBar && window.bbNamesPrefill) window.bbNamesPrefill(d.names.list || []);
      else if (d.names) { setVal('mb-name-line', d.names.name || ''); setVal('mb-anecdote-line', d.names.anecdote || ''); }
    }
    if (window.bbGiftRender) window.bbGiftRender();
  }
  function restore() {
    if (handoffPending) return;   // homepage AI-box edit wins
    var raw; try { raw = localStorage.getItem(KEY); } catch (e) { return; }
    if (!raw) return;
    var d; try { d = JSON.parse(raw); } catch (e) { clearDraft(); return; }
    if (!d || !d.mode || !d.ts || (Date.now() - d.ts) > MAXAGE) { clearDraft(); return; }
    try {
      var sc = document.querySelector('.bb-size-card[data-size="' + (d.count === 12 ? 12 : 6) + '"]');
      if (sc && !sc.classList.contains('selected')) sc.click();
      if (d.flavours && d.flavours.length) setFlavours(d.flavours);
      // Personaliser mode/story is NOT restored — clicking the saved story card would
      // set the story (and the personalised price) with empty inputs. The box always
      // starts on the empty default (base price, nothing selected) until you interact.
      // (Box size + flavours above still resume.)
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(restore, 0); });
  else setTimeout(restore, 0);
})();

